import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import $ from "jquery";
import { FORM_DATE_TIME_FORMAT, FORM_TIME_FORMAT, IMAGE_URL, TABLE_DATE_FORMAT, TABLE_TIME_FORMAT } from "../../../../utils/Constants";
import Select from "react-select";
import {
  GetIntakeDetails,
  GetQuestionsByQuiz,
  GetQuiz,
  getAssignedGrademixViaAssessment,
  getSickAssessmentStudentList,
  getSupplementaryStdList,
  lockedProgrammes,
} from "../../../../services/CourseService";
import {
  getOverrideAssessments,
  SendAssessmentInstruction,
  AddAssessment,
  GetAssessmentsData,
  FetchAssessmentDetails
} from "../../../../services/AssessmentService";
import Swal from "sweetalert2";
import { Link, useHistory, useParams } from "react-router-dom";
import HtmlInputEditor from "../../../common/HtmlInputEditor";
import {
  convertFromRaw,
  convertToRaw,
  EditorState,
} from "draft-js";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import PermissionsGate from "../../../../utils/permissionGate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { myCompare } from "../../../common/MyCompare";
import { CheckJSONString } from "../../../common/CheckJSONString";
import draftToHtml from "draftjs-to-html";
import { TrimText } from "../../../common/TrimText";
import AddQuizzTable from "./AddQuizzTable";
import { setAssessmentName } from "../../../../store/actions";
import ListOfTemplateModal from "../../CourseGradeSettings/ListOfTemplateModal";
import { GradeLetterTemplateList } from "../../../../services/GradeSettingService";
import ProgrammeGradeMixModal from "../../Programs/ProgrammeGradeMixModal";
import LinkCourseModal from "./LinkCourseModal";
import PopupComponent from "../../../common/PopupComponent";
import { InitialRender } from "../../../common/Helper";
import Hover from '../../../common/Hover';
import { RenderAssessmentStatus, RenderQuizAttemptResultStatus, RenderStudentStatus } from "../../../../utils/CommonStatusItems";
import DataTableComponentFrontPagination from "../../../common/DataTableComponentFrontPagination";
import { RenderAssessmentType } from "../../../../utils/CommonGroupingItem";
import Dropzone from "react-dropzone";
import formatUrl from "../../../common/formatUrl";
import { handleGradesLocked } from "../../../../utils/commonFunction";
import axios from "axios";

const AssessmentForm = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { id, tab, type, subId, subTab } = useParams();
  const [assessmentType, setAssessmentType] = useState([]);
  const [moderatorAndMarker, setModeratorAndMarker] = useState([]);
  const [moderatorSelected, setModeratorSelected] = useState([]);
  const [assessmentTypeSelected, setassessmentTypeSelected] = useState();
  const [gradeSelected, setGradeSelected] = useState();
  const [assessmentFile, setAssessmentFile] = useState();
  const [gradeType, setGradeType] = useState([]);
  const [gradeMixGradeType, setGradeMixGradeType] = useState([]);
  const [assessmentFileName, setAssessmentFileName] = useState();
  const [memoFile, setMemoFile] = useState(null);
  const [memofileName, setMemofileName] = useState();
  const [editorState, setEditorState] = useState("");
  const [assessmentDetails, setAssessmentDetails] = useState({});
  const [selectedDomain, setSelectedDomain] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quizTotal, setQuizTotal] = useState("");
  const [quizLabel, setQuizLabel] = useState("");
  const [assessmentLoad, setAssessmentLoad] = useState(false);
  const [apiDataLoaded, setApiDataLoaded] = useState(false);
  const [isDurationDisabled, setIsDurationDisabled] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [selectedGradeMixTemplate, setSelectedGradeMixTemplate] = useState({});
  const [statusAvailableList, setStatusAvailableList] = useState([]);
  const [courseResultAvailableList, setCourseResultAvailableList] = useState([]);
  const [statusAssignedList, setStatusAssignedList] = useState([]);
  const [courseResultAssignedList, setCourseResultAssignedList] = useState([])
  const [statusAssigned, setStatusAssigned] = useState({ arr: [], checkObj: {} })
  const [courseResultAssigned, setCourseResultAssigned] = useState({ arr: [], checkObj: {} })
  const [statusAvailable, setStatusAvailable] = useState({ arr: [], checkObj: {} });
  const [courseResultAvailable, setCourseResultAvailable] = useState({ arr: [], checkObj: {} });
  const [searchAssigned, setSearchAssigned] = useState("");
  const [availableStudentList, setAvailableStudentList] = useState([])
  const [availableSearch, setAvailableSearch] = useState("");
  const [availableLoading, setAvailableLoading] = useState(false);
  const [assignedStudentList, setAssignedStudentList] = useState([])
  const [assignloading, setAssignloading] = useState(false);
  const [overrideAssessList, setOverrideAssessList] = useState([]);
  const [overrideSearch, setOverrideSearch] = useState("");
  const [overrideLoading, setOverrideLoading] = useState(false);
  const [overrideStatusList, setOverrideStatusList] = useState([]);
  const [overrideStatus, setOverrideStatus] = useState({ arr: [], checkObj: {} });
  const [overrideAssessTypeList, setOverrideAssessTypeList] = useState([]);
  const [overrideAssessType, setOverrideAssessType] = useState({ arr: [], checkObj: {} });
  const [refresh, setRefresh] = useState(false);
  const [checkedAllRows, setCheckedAllRows] = useState([]);
  const [tempCheckedAllData, setTempCheckedAllData] = useState([]);
  const [lettertemplateIndex, setLettertemplateIndex] = useState();
  const [reload, setReload] = useState(false);
  const [gradeMixError, setGradeMixError] = useState([]);
  const [courseError, setCourseError] = useState([]);
  const [touchedStates, setTouchedStates] = useState([]);
  const [assignLoading, setAssignLoading] = useState(false)
  const [overrideMarkFor, setOverrideMarkFor] = useState("")
  const [selectedStudentId, setSelectedStudentId] = useState();
  const [appealReason, setAppealReason] = useState('');
  const [studentMessage, setStudentMessage] = useState('');
  const [selectedFileForAppeal, setSelectedFileForAppeal] = useState([]);
  const [appealError, setAppealError] = useState("");
  const [newAssignee, setNewAssignee] = useState([]);
  const [overRideId, setOverRideId] = useState();
  const [linkCourseData, setLinkCourseData] = useState([]);
  const [checkLetterTemplateCourse, setCheckLetterTemplateCourse] = useState(false)
  const [linkCheckedAllRows, setLinkCheckedAllRows] = useState([]);
  const [intakeDetails, setIntakeDetails] = useState({});
  const [handleRefreshCourseList, setHandleRefreshCourseList] = useState(Date.now());
  const [letterTemplateCourse, setLetterTemplateCourse] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState({});
  const hasFetchedRef = useRef(false);
  const assessmentFileInputRef = useRef(null);
  const memoFileInputRef = useRef(null);
  const [overrideSelected, setOverrideSelected] = useState({});
  const [letterTemplateOption, setLetterTemplateOption] = useState([]);
  const [isFetchOption, setIsFetchOption] = useState(false);
  const [linkedProgrammes, setLinkedProgrammes] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const prevIntakeIdsRef = useRef('');
  /**
    Boolean that is true if we are past the open date and the action is open (which means edit view)
  */

  const assessmentActive = (type === "open" && assessmentDetails &&
    assessmentDetails.openDateAndTime &&
    assessmentDetails.openDateAndTime !== "NaN"
    && Number(assessmentDetails.openDateAndTime) <= moment().valueOf());
  useEffect(() => {
    if (quizTotal) {
      let arr = tempCheckedAllData.map(item => ({ ...item, assessment_total: quizTotal }))
      setTempCheckedAllData([...arr])
    }
  }, [checkedAllRows])

  useEffect(() => {
    if (quizTotal) {
      let arr = linkCourseData.map(item => ({ ...item, assessment_total: quizTotal }))
      setLinkCourseData([...arr])
    }
  }, [quizTotal, linkCheckedAllRows])
  
  useEffect(() => {
    let newData = letterTemplateCourse ? linkCourseData : tempCheckedAllData;

    if (newData.length && (Object.keys(selectedCourse).length > 0 || letterTemplateCourse == true)) {
      setLinkCourseData((prevData) => {
        const newData = [...prevData];
        newData[lettertemplateIndex] = {
          ...newData[lettertemplateIndex],
          selectedTemplate: selectedCourse,
        };
        let templateGrdaeMixPassMarkArr = [];
        let templateGrdaeMixArray =
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
            (item) => {
              templateGrdaeMixPassMarkArr.push({
                value: item?.id,
                label: item?.text,
              });
              newData[lettertemplateIndex].templateOptions = templateGrdaeMixPassMarkArr;
            }
          );
        return newData;
      });
    } else if (newData.length && newData[lettertemplateIndex]?.selectedTemplate) {
      setTempCheckedAllData((prevData) => {
        const newData = [...prevData];
        newData[lettertemplateIndex].selectedTemplate =
          selectedGradeMixTemplate;
        let templateGrdaeMixPassMarkArr = [];
        let templateGrdaeMixArray =
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
          newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
            (item) => {
              templateGrdaeMixPassMarkArr.push({
                value: item?.id,
                label: item?.text,
              });
              newData[lettertemplateIndex].templateOptions =
                templateGrdaeMixPassMarkArr;
            }
          );
        return newData;
      });
    } else if (newData.length) {
      if (!letterTemplateCourse) {
        setTempCheckedAllData((prevData) => {
          const newData = [...prevData];
          newData[lettertemplateIndex] = {
            ...newData[lettertemplateIndex],
            selectedTemplate: selectedGradeMixTemplate,
          };
          let templateGrdaeMixPassMarkArr = [];
          let templateGrdaeMixArray =
            newData[lettertemplateIndex].selectedTemplate?.gradeOptions?.length &&
            newData[lettertemplateIndex].selectedTemplate?.gradeOptions.map(
              (item) => {
                templateGrdaeMixPassMarkArr.push({
                  value: item?.id,
                  label: item?.text,
                });
                newData[lettertemplateIndex].templateOptions =
                  templateGrdaeMixPassMarkArr;
              }
            );
          return newData;
        });
      }
    }
  }, [selectedGradeMixTemplate, reload, selectedCourse, letterTemplateCourse]);

  let templatePassMarkArr = [];
  let templateArray =
    selectedTemplate?.gradeOptions?.length &&
    selectedTemplate?.gradeOptions.map((item) => {
      templatePassMarkArr.push({
        value: item?.id,
        label: item?.text,
      });
    });

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };


  const sortingName = (rowA, rowB) => {
    const name1 = rowA.name ? rowA.name.toString() : "";
    const name2 = rowB.name ? rowB.name.toString() : "";
    return name1.localeCompare(name2);
  };


  const sortingStudentName = (rowA, rowB) => {
    const name1 = rowA.full_name ? rowA.full_name.toString() : "";
    const name2 = rowB.full_name ? rowB.full_name.toString() : "";
    return name1.localeCompare(name2);
  };

  const GetLetterTemplateOption = async () => {
    if (isFetchOption || letterTemplateOption.length) return letterTemplateOption;
  
    try {
      const res = await GradeLetterTemplateList({ exportStatus: true });
      setLetterTemplateOption(res);
      setIsFetchOption(true);
      return res;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const stdNoSort = (rowA, rowB) => {
    const name1 = rowA?.student_crm_id ? +rowA.student_crm_id : 0;
    const name2 = rowB?.student_crm_id ? +rowB.student_crm_id : 0;
    return name1 - name2;
  };


  const passMarkRobotArr = [
    {
      label: "Red",
      value: 0,
    },
    {
      label: "Yellow",
      value: 49,
    },
    {
      label: "Green",
      value: 100,
    },
  ]

  useEffect(() => {
    if (overRideId || assessmentTypeSelected == 8) {

      let data = {
        intake_id: id,
        assessment_id: assessmentDetails?.id || subId,
        override_mark_ass_id: overRideId,
      }
      if (assessmentTypeSelected == 8) {
        setAvailableLoading(true)
        getSupplementaryStdList(data).then(res => {
          setAvailableStudentList(res.data.list)
          setCourseResultAvailableList(res.data.course_result)
          setStatusAvailableList(res.data.status)
        }
        ).catch(err => {
          console.error("error", err)
        }).finally(() => setAvailableLoading(false))
      } else if (assessmentTypeSelected == 9) {
        setAvailableLoading(true)

        getSickAssessmentStudentList(data).then(res => {
          setAvailableStudentList(res.data.list || [])
          setCourseResultAvailableList(res.data.course_result || [])
          setStatusAvailableList(res.data.status || [])
        }
        ).catch(err => {
          console.error("error", err)
        }).finally(() => setAvailableLoading(false))
      }
    }
  }, [refresh, assessmentTypeSelected, overRideId])

  useEffect(() => {
    if (type !== "duplicate" && type !== "add") {

      let data = {
        intake_id: id,
        assessment_id: assessmentDetails?.id || subId,
        type: "assigned",
      }
      if (assessmentTypeSelected == 8) {
        getSupplementaryStdList(data).then(res => {
          setAssignedStudentList(res.data.list)
          setCourseResultAssignedList(res.data.course_result)
          setStatusAssignedList(res.data.status)
          setAssignloading(false)
        }
        ).catch(err => {
          setAssignloading(false)
          console.error("error", err)
        })
      } else if (assessmentTypeSelected == 9) {
        getSickAssessmentStudentList(data).then(res => {
          const assignedStudents = res.data.list || [];
          setAssignedStudentList(
            assignedStudents.map(item => ({
              ...item,
              isAssigned: true,
            }))
          );
          setCourseResultAssignedList(res.data.course_result || []);
          setStatusAssignedList(res.data.status || []);
          setAssignloading(false);
        }
        ).catch(err => {
          setAssignloading(false)
          console.error("error", err)
        })
      }
    }
  }, [refresh, assessmentTypeSelected, type, assessmentDetails?.id]);

  const overrideAssessColumns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortFunction: sortingName,
      cell: (row) => {
        return (
          <span
            title={row.name}
            className="overflow-ellipsis2 ">
            {row.name ?
              <Link className="as-text-blue curser feature-name"
                target="_blank"
                to={row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
              >
                <span className="textLimit100">{row.name}</span>
              </Link> :
              "-"}
          </span>
        )
      }
    },
    {
      name: "Assessment Type",
      selector: "type",
      sortable: true,
      cell: (row) => (
        row.type ? RenderAssessmentType(row.type).html : "-"
      )
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderAssessmentStatus(row.status).html : "-",
    },
    {
      name: "Due Date",
      selector: "close_date_time_mili",
      sortable: true,
      cell: (row) => (
        row.close_date_time_mili ?
          <>
            <p className="right-space">{moment.unix(row.close_date_time_mili).format(TABLE_DATE_FORMAT)}</p>
            <p>{moment.unix(row.close_date_time_mili).format(TABLE_TIME_FORMAT)}</p>
          </>
          : "-"
      )
    },
    {
      name: "Actions",
      selector: "Action",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              title="Open"
              className="btn btn-primary rounded-circle"
              target="_blank"
              to={row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            {row.id == formik.values.override_mark_ass_id ? <button
              title="Remove"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => {
                formik.setFieldValue("override_mark_ass_id", "");
                formik.setFieldValue("override_mark_ass_type", "");
                formik.setFieldValue("maxGradeAchievable", "");
                setCheckedAllRows([]);
                setTempCheckedAllData([]);
                setLinkCourseData([])
              }}
            >
              <i className="fal fa-minus"></i>
            </button> :
              <button
                title="Add"
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => {
                  formik.setFieldValue("override_mark_ass_id", row.id);
                  formik.setFieldValue("override_mark_ass_type", row.ass_type);
                  formik.setFieldValue("maxGradeAchievable", row.maximum_grade_achievable);
                  if (props.gradingStandard == 2) getOverrideGrademixList(row.id);
                  setOverRideId(row.id)
                  setLinkCourseData(row?.spAssessmentLinks)
                }}
              >
                <i className="fal fa-plus"></i>
              </button>}
          </div>
        </div>
      ),
    }
  ])

  const studentColumns = useMemo(() => [
    {
      name: "Student",
      selector: "full_name",
      sortable: true,
      sortFunction: sortingStudentName,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon cat-dark-red "}>
              {row?.photo ? (
                <img
                  src={`${IMAGE_URL}/${row?.photo
                    .replaceAll("/home/myaie/public_html/", "")
                    .replace("public/", "")}`}
                  alt="AIE"
                />
              ) : (
                InitialRender([
                  row.first_name,
                  row.last_name,
                ])
              )}
              <span
                className={`profile-box-2-status ${row.activity_status
                  ? row.activity_status.toLowerCase() == "online"
                    ? "Online"
                    : row.activity_status.toLowerCase() == "away"
                      ? "Away"
                      : "Offline"
                  : "Offline"
                  }`}
              >
                <i className="fas fa-circle"></i>
              </span>
              <Hover
                firstName={row.first_name}
                lastName={row.last_name}
                photo={row.photo}
                email={row.email}
                mobile={row.mobile}
                right={true}
                status={row.status}
                activity_status={row.activity_status}
                showNumber={true}
                number={row.student_crm_id}
              />
            </span>
            <Link
              to={`/studentAdministration/students/open/${row.student_id}/general`}
              target="_blank"
              className="as-text-blue curser feature-name width-155"
            >
              <span className="textLimit100">{row.full_name}</span>
            </Link>
          </div>
        </div>
      ),
    },
    {
      name: "Student No.",
      selector: "student_crm_id",
      sortFunction: stdNoSort,
      sortable: true,
      cell: (row) =>
        row.student_crm_id ? (
          <span className="feature-name">
            <span className="textLimit100">{row.student_crm_id}</span>
          </span>
        ) : (
          "-"
        ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderStudentStatus(row.status).html : "-",
    },
    {
      name: "Course Grade",
      selector: "course_grade",
      sortable: true,
      cell: (row) => row.course_grade ? row.course_grade : "-",
    },
    {
      name: "Course Result",
      selector: "pass_status",
      sortable: true,
      cell: (row) => row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).html : "-",
    },
    {
      name: "Actions",
      selector: "Action",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              title="Open"
              className="btn btn-primary rounded-circle"
              to={`/studentAdministration/students/open/${row.student_id}/general`}
              target="_blank"
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            {assessmentTypeSelected == 8 ? row.isAssigned ? <button
              title="Remove"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => handleRemoveStd(row)}
            >
              <i className="fal fa-user-minus"></i>
            </button> :
              <button
                title="Add"
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => handleAddStd(row)}
              >
                <i className="fal fa-user-plus"></i>
              </button> : assessmentTypeSelected == 9 && !row.isAssigned ? <button
                title="Add"
                type="button"
                className="btn btn-primary rounded-circle"
                data-toggle="modal"
                data-target="#assignStudent"
                onClick={() => setSelectedStudentId(row.student_id)}
              >
                <i className="fal fa-user-plus"></i>
              </button> : ""}
          </div>
        </div>
      ),
    },
  ]);


  const handleGetCourseDetails = () => {
    GetIntakeDetails(id)
      .then(res => {
        if (res.status == 200) {
          setIntakeDetails(res.data.data)
        }
      })
      .catch(err => {
        console.error("error >>>>>> ", err)
      })
  }

  useEffect(() => {
    handleGetCourseDetails()
  }, [])

  const getOverrideGrademixList = (id) => {
    getAssignedGrademixViaAssessment({ assessment_id: id })
      .then((response) => {
        const data = {
          exportStatus: true,
        };
        GradeLetterTemplateList(data)
          .then((res) => {
            let ls = [...checkedAllRows];
            let newData = response?.data?.getGradeMix.map(
              (gradeMix, index) => {
                ls.push(Number(gradeMix?.grade_id));
                let templateGrdaeMixPassMarkArr = [];
                let tempMixObj = res.data.list_data?.find(
                  (item) => item.id === gradeMix?.grading_template_id
                );
                let templateGrdaeMixArray =
                  tempMixObj?.gradeOptions?.length &&
                  tempMixObj?.gradeOptions.map((item) => {
                    templateGrdaeMixPassMarkArr.push({
                      value: item?.id,
                      label: item?.text,
                    });
                  });
                return {
                  ...gradeMix,
                  selectedTemplate: tempMixObj ? tempMixObj : {},
                  templateOptions: templateGrdaeMixPassMarkArr,
                };
              }
            );
            setCheckedAllRows([...ls]);
            setTempCheckedAllData([...newData]);
          })
          .catch((err) => {
            console.error(err);
          });
      }).catch((err) => {
        console.error(err, "error")
      })
  }

  useEffect(() => {
    if (props.lmType === "selfplaced") {
      formik.setFieldValue("allowAppeal", false);
    }
    setDataLoading(true)
    GetAssessmentsData(id, subId)
      .then((res) => {
        let x = {
          value: "",
          label: "",
        };
        x = res?.data?.assessment_moderator_marker.map((data) => {
          return { ...x, value: `${data.UserID}`, label: `${data.name}` };
        });
        setModeratorAndMarker(x);
        let tempAssessmentTypeArr = [];
        const assArr = res?.data?.assessment_type;
        Object.keys(assArr).map((key, index) => {
          tempAssessmentTypeArr.push({
            value: key,
            label: assArr[key],
            key: key,
          });
        });
        setAssessmentType(tempAssessmentTypeArr);
        //setting Grade
        let tempGradeArr = [
          {
            value: "2",
            label: "Letter",
            key: 2,
          },
          {
            value: "3",
            label: "Value",
            key: 3,
          },
          {
            value: "4",
            label: "No Grade",
            key: 4,
          },
        ];
        const gradeArr = res?.data?.grade;
        Object.keys(gradeArr).map((key, index) => {
          tempGradeArr.push({ value: key, label: gradeArr[key], key: key });
        });
        setGradeType(tempGradeArr);
        setGradeMixGradeType(tempGradeArr);
        setDataLoading(false);
        setApiDataLoaded(true);
      })
      .catch((error) => {
        setDataLoading(false);
        setApiDataLoaded(true);
        console.error("error: ", error);
      });
    if (type != "add" && id) {
      setAssignLoading(true)
      FetchAssessmentDetails(subId, id)
        .then((response) => {
          const tempAssessmentDetails = response?.data;
          setAssessmentDetails(response?.data);
          setOverRideId(response.data.override_mark_ass_id)
          formik.setFieldValue("isHybrid", response.data.isHybrid);
          setEditorState(response?.data?.details);
          dispatch(setAssessmentName(response.data.name));
          setTempCheckedAllData(response.data.getGradeMix);

          setAssessmentFile(response.data?.path);
          setAssessmentFileName(response.data?.path);
          setMemoFile(response.data?.path_marking);
          setMemofileName(response.data?.path_marking);
          setGradeSelected(tempAssessmentDetails?.grading_type);
          setModeratorSelected(
            tempAssessmentDetails && tempAssessmentDetails.assessment_moderator
              ? tempAssessmentDetails.assessment_moderator
              : []
          );
          setLinkCourseData(response?.data?.spAssessmentLinks)
          setLinkCheckedAllRows(response?.data?.spAssessmentLinks)
          setassessmentTypeSelected(response?.data?.ass_type);
          response?.data.assessment_marker_multiple &&
            setSelectedDomain(
              response?.data.assessment_marker_multiple?.length > 0 ? response?.data.assessment_marker_multiple?.split(",") : []
            );
          quizFormik.setFieldValue("quiz_id", response.data?.quiz_id);
          formik.setFieldValue("allowAppeal", response.data?.allowAppeal ? true : false);
          if (response.data?.quiz_id) {
            formik.setFieldValue("quiz_id", true);
            setQuizTotal(response?.data?.ass_total_mark);
          }
          let check = CheckJSONString(response?.data?.details);
          if (check) {
            const blocksFromHTML2 = convertFromRaw(
              JSON.parse(response?.data?.details)
            );
            let dataDescr = EditorState.createWithContent(blocksFromHTML2);
            const detail = draftToHtml(
              convertToRaw(dataDescr.getCurrentContent())
            );
            setEditorState(detail ? detail : "<p><p/>");
            setApiDataLoaded(true);
          } else {
            setEditorState(response?.data?.details);
            setApiDataLoaded(true);
          }

          formik.setFieldValue(
            "maximum_attempts",
            response?.data?.maximum_attempts == 0
              ? "0"
              : response?.data?.maximum_attempts
          );

          if (tempAssessmentDetails?.grading_type == 2 && !hasFetchedRef.current) {
            GetLetterTemplateOption()
              .then(async (res) => {
                let tempObj = res?.data.list_data?.find(
                  (item) => item.id === response.data.grading_template_id
                );
                setSelectedTemplate(tempObj);
                let ls = [...checkedAllRows];
                let newData = response?.data?.getGradeMix?.map(
                  (gradeMix, index) => {
                    ls.push(Number(gradeMix?.grade_id));
                    let templateGrdaeMixPassMarkArr = [];
                    let tempMixObj = res.data.list_data?.find(
                      (item) => item.id === gradeMix?.grading_template_id
                    );
                    let templateGrdaeMixArray =
                      tempMixObj?.gradeOptions?.length &&
                      tempMixObj?.gradeOptions.map((item) => {
                        templateGrdaeMixPassMarkArr.push({
                          value: item?.id,
                          label: item?.text,
                        });
                      });
                    return {
                      ...gradeMix,
                      selectedTemplate: tempMixObj ? tempMixObj : {},
                      templateOptions: templateGrdaeMixPassMarkArr,
                    };
                  }
                );
                await setTempCheckedAllData([...newData]);
                await setCheckedAllRows([...ls]);
                setAssignLoading(false)
                hasFetchedRef.current = true;
                setCheckLetterTemplateCourse(true)
              })
              .catch((err) => {
                console.error(err);
                setLoading(false);
                setAssignLoading(false)
              });
          } else {
            setCheckLetterTemplateCourse(true)
          }
        })
        .catch((error) => {
          console.error("error :", error);
        })
        .finally(() => {
          setAssignLoading(false)
        })
    } else {
      setApiDataLoaded(true);
    }
  }, [refresh]);

  useEffect(() => {
    if (checkLetterTemplateCourse && linkCourseData?.length > 0) {
      const isAlreadyProcessed = linkCourseData.some((data) => data.templateOptions);
  
      if (!isAlreadyProcessed) {
        const isLetterType = linkCourseData.some((data) => data.grading_type == 2);
        
        if (isLetterType) {
          GetLetterTemplateOption()
            .then((res) => {
              const templateList = res?.data?.list_data ?? [];
              
              // Use functional update to avoid stale closure
              setLinkCourseData(prevData => {
                return prevData?.map((course) => {
                  if (course.grading_template_id) {
                    // Ensure proper type comparison
                    const matchedTemplate = templateList?.find(
                      template => String(template?.id) === String(course?.grading_template_id)
                    );
                    
                    return {
                      ...course,
                      selectedTemplate: matchedTemplate || null,
                      templateOptions: matchedTemplate?.gradeOptions?.map((item) => ({
                        value: item.id,
                        label: item.text,
                      })) ?? [],
                    };
                  }
                  return course;
                });
              });
              
              const isIndex = linkCourseData.findIndex((data) => data.grading_type == 2);
              setLetterTemplateCourse(true);
              setLettertemplateIndex(isIndex);
              setCheckLetterTemplateCourse(false);
            })
            .catch((err) => {
              setCheckLetterTemplateCourse(false);
            });
        } else {
          setCheckLetterTemplateCourse(false);
        }
      }
    }
  }, [checkLetterTemplateCourse]);

  useEffect(() => {
    let shouldUpdate = false;

    const updatedData = linkCourseData?.map((item) => {
      if (item.grading_type === 4) {
        // Only update if fields are missing or incorrect
        const needsUpdate =
          item.assessment_total !== 0 ||
          item.pass_mark !== 0 ||
          item.exclude_from_calculation !== true;

        if (needsUpdate) {
          shouldUpdate = true;
          return {
            ...item,
            assessment_total: 0,
            pass_mark: 0,
            exclude_from_calculation: true,
          };
        }
      }
      return item;
    });

    if (shouldUpdate) {
      setLinkCourseData(updatedData);
    }
  }, [linkCourseData]);

  useEffect(() => {
    const getIntakesIds = (intakeArray) => {
      let intakes = [Number(id)];
      intakeArray.forEach((intakeData) => {
        if (intakeData.intake && intakeData.isDelete !== 1) {
          intakes.push(intakeData.intake);
        }
      });
      return [...new Set(intakes)];
    };

    const getLockedProgramme = async () => {
      try {
        const intakeIds = getIntakesIds(linkCourseData);
        const intakeIdsString = intakeIds.sort((a, b) => a - b).join(',');

        if (prevIntakeIdsRef.current !== intakeIdsString) {
          prevIntakeIdsRef.current = intakeIdsString;

          setIsDisabled(true);
          const payload = { intake_id: intakeIds };
          const { data: lockedProgrammeResult } = await lockedProgrammes(payload);
          if (lockedProgrammeResult.success) {
            setIsDisabled(false);
            setLinkedProgrammes(lockedProgrammeResult);
          }
        }
      } catch (error) {
        console.log(error);
        setIsDisabled(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.message || "Something went wrong",
        });
      }
    };

    if (assessmentDetails?.intake || type === "add" ) {
      getLockedProgramme();
    }

  }, [linkCourseData, id]);

  const getTimeMinutes = (data) => {
    if (`${data}`.length < 2) {
      return "0" + data;
    } else {
      return `${data}`;
    }
  };

  const quizFormik = useFormik({
    initialValues: {
      quiz_id: "",
    },
    validationSchema: Yup.object({
      quiz_id: Yup.string().required("Quiz is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      $("#quiz").modal("hide");
      GetQuestionsByQuiz(values.quiz_id)
        .then((res) => {
          setQuizTotal(res.data.totalQuizScore);
          let arr = tempCheckedAllData.map(item => {
            return {
              ...item,
              assessment_total: res.data.totalQuizScore
            }
          })
          setTempCheckedAllData([...arr])
          formik.setFieldValue(
            "AssessmentTotal",
            res.data.totalQuizScore.toString()
          );
          formik.setFieldValue(
            "isDuration",
            res.data.totalQuizScore.toString()
          );
          formik.setFieldValue(
            "TimeLimitHours",
            res.data.description.time_limit_hours != null &&
              res.data.description.time_limit_hours > 0
              ? res.data.description.time_limit_hours
              : res.data.description.time_limit_minutes > 0
                ? "00"
                : ""
          );
          formik.setFieldValue(
            "TimeLimitMinutes",
            res.data.description.time_limit_minutes != null &&
              res.data.description.time_limit_minutes > 0
              ? res.data.description.time_limit_minutes
              : res.data.description.time_limit_hours > 0
                ? "00"
                : ""
          );
          formik.setFieldValue("quiz_id", values.quiz_id);
          formik.setFieldValue(
            "maximum_attempts",
            res.data.description.maximum_attempts
          );
          formik.setFieldValue("isHybrid", res.data.description.isHybrid);

        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  useEffect(() => {
    if (formik.values.quizCheck && quizFormik.values.quiz_id != "") {
      GetQuiz({ getPaginate: "true", quizId: quizFormik.values.quiz_id }).then(
        (res) => {
          if (Array.isArray(res?.data) && res?.data.length) {
            res.data.map((val) => {
              if (val.quid == quizFormik.values.quiz_id) {
                formik.setFieldValue("quiz_id", true);
                setIsDurationDisabled(true);
                setQuizLabel(val.quiz_name.trim());
              }
            });
          }
        }
      );
    }
  }, [quizFormik.values.quiz_id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      AssessmentName:
        assessmentDetails && assessmentDetails?.name
          ? assessmentDetails?.name
          : "",
      AssessmentType: assessmentDetails
        ? assessmentDetails?.ass_type == 0
          ? "0"
          : assessmentDetails?.ass_type
        : "",
      AssessmentTotal: assessmentDetails
        ? assessmentDetails.ass_total_mark == 0
          ? "0"
          : assessmentDetails?.ass_total_mark
        : "",
      Weight:
        assessmentDetails && assessmentDetails?.ass_weighting >= 0
          ? assessmentDetails?.ass_weighting
          : "",
      Code:
        assessmentDetails && assessmentDetails?.code
          ? assessmentDetails?.code
          : "",
      GradeType: assessmentDetails && assessmentDetails?.grading_type,
      Marker:
        assessmentDetails && assessmentDetails?.assessment_marker
          ? assessmentDetails?.assessment_marker_multiple
            ? (
              assessmentDetails?.assessment_marker +
              "," +
              assessmentDetails?.assessment_marker_multiple
            ).split(",")
            : [assessmentDetails?.assessment_marker]
          : [],
      Moderator:
        assessmentDetails && assessmentDetails?.assessment_moderator
          ? assessmentDetails?.assessment_moderator
          : "",
      Moderated:
        assessmentDetails && assessmentDetails?.notify_moderator
          ? assessmentDetails?.notify_moderator
          : "0",
      AssessmentFile:
        assessmentDetails && assessmentDetails?.path
          ? assessmentDetails?.path
          : "",
      MemoFile:
        assessmentDetails && assessmentDetails?.path_marking
          ? assessmentDetails?.path_marking
          : "",
      TimeLimitHours:
        assessmentDetails.timeHour > 0 && assessmentDetails.timeHour != null
          ? `${assessmentDetails?.timeHour}`.length
            ? getTimeMinutes(assessmentDetails?.timeHour)
            : ""
          : assessmentDetails?.timeMin > 0
            ? "00"
            : "",
      TimeLimitMinutes:
        assessmentDetails?.timeMin > 0 && assessmentDetails?.timeMin != null
          ? `${assessmentDetails?.timeMin}`.length
            ? getTimeMinutes(assessmentDetails?.timeMin)
            : ""
          : assessmentDetails.timeHour > 0
            ? "00"
            : "",
      Identification:
        assessmentDetails && assessmentDetails?.identification ? true : false,
      Camera:
        assessmentDetails && assessmentDetails?.camera
          ? assessmentDetails?.camera
          : "",
      ScreenShare:
        assessmentDetails && assessmentDetails?.screen_share
          ? assessmentDetails?.screen_share
          : "",
      Audio:
        assessmentDetails && assessmentDetails?.audio
          ? assessmentDetails?.audio
          : "",
      openDateAndTime:
        assessmentDetails &&
          assessmentDetails.openDateAndTime &&
          assessmentDetails.openDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.openDateAndTime))
          : "",
      closeDateAndTime:
        assessmentDetails &&
          assessmentDetails.closeDateAndTime &&
          assessmentDetails.closeDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.closeDateAndTime))
          : "",
      deadlineDateAndTime:
        assessmentDetails &&
          assessmentDetails.deadlineDateAndTime &&
          assessmentDetails.deadlineDateAndTime !== "NaN"
          ? new Date(parseInt(assessmentDetails.deadlineDateAndTime))
          : "",
      appealCloseDate:
        assessmentDetails &&
          assessmentDetails.appealCloseDate &&
          assessmentDetails.appealCloseDate !== "NaN"
          ? new Date(parseInt(assessmentDetails.appealCloseDate))
          : "",
      appealOpenDate:
        assessmentDetails &&
          assessmentDetails.appealOpenDate &&
          assessmentDetails.appealOpenDate !== "NaN"
          ? new Date(parseInt(assessmentDetails.appealOpenDate))
          : "",
      allowAppeal:
        assessmentDetails && assessmentDetails.allowAppeal == 1 ? true : false,
      isDuration:
        assessmentDetails && assessmentDetails.timeLimitActive ? true : false,
      multiplicator:
        assessmentDetails && assessmentDetails?.multiplicator
          ? assessmentDetails?.multiplicator
          : "",
      offset:
        assessmentDetails && assessmentDetails?.offset
          ? assessmentDetails?.offset
          : "",
      passMark:
        assessmentDetails && assessmentDetails?.pass_mark
          ? assessmentDetails?.pass_mark
          : "",
      details: "",
      quiz_id: "",
      maximum_attempts: assessmentDetails && assessmentDetails?.maximum_attempts ? assessmentDetails?.maximum_attempts : "",
      quizCheck: assessmentDetails && assessmentDetails.quiz_id
        ? true
        : false,
      isHybrid: assessmentDetails && assessmentDetails?.isHybrid ? assessmentDetails?.isHybrid : false,
      gradeMix: [],
      grading_standard: props?.gradingStandard ? props?.gradingStandard : 4,
      maxGradeAchievable: assessmentDetails && assessmentDetails?.maximum_grade_achievable ? assessmentDetails?.maximum_grade_achievable : 50,
      override_mark_ass_id: type == "duplicate" ? "" : assessmentDetails && assessmentDetails?.override_mark_ass_id ? assessmentDetails?.override_mark_ass_id : "",
      override_mark_ass_type: "",
      aggregation_method_id: intakeDetails?.aggregation_method_id,
      shareWith: assessmentDetails && assessmentDetails?.share_with ? assessmentDetails?.share_with : [],
      isDownloadAllowed: assessmentDetails && assessmentDetails?.is_download_allowed == 1 ? true : false,
      is_student_signature_required: assessmentDetails && assessmentDetails?.is_student_signature_required == 1 ? 1 : 0,
      is_marker_signature_required: assessmentDetails && assessmentDetails?.is_marker_signature_required == 1 ? 1 : 0,
      pass_required: assessmentDetails && assessmentDetails.pass_required == 1 ? 1 : 0,
      exclude_from_calculation: assessmentDetails && assessmentDetails.exclude_from_calculation == 1 ? 1 : 0,
      linkAssessmentCourse: [],
      path_size: assessmentDetails?.path_size,
    },
    validate: (values) => {
      const errors = {};

      // Time limit validation - runs on every change
      if ((values.quizCheck || values.isDuration) &&
        values.openDateAndTime &&
        values.closeDateAndTime &&
        values.TimeLimitHours &&
        values.TimeLimitMinutes) {

        const totalMinutes = Number(values.TimeLimitHours) * 60 + Number(values.TimeLimitMinutes);
        const availableMinutes = moment(values.closeDateAndTime).diff(
          moment(values.openDateAndTime),
          "minutes"
        );

        if (totalMinutes > availableMinutes) {
          errors.TimeLimitHours = "Time limit exceeds available assessment duration";
        }
      }

      return errors;
    },
    validationSchema: Yup.object({
      AssessmentName: Yup.string()
        .required("Assessment Name is required")
        .trim(),
      AssessmentType: Yup.string()
        .required("Assessment Type is required")
        .test(
          "no-courses-allowed-for-supplementary",
          "No courses can be linked for Supplementary assessment type.",
          (value) => {
            // Only care about Supplementary / Sick (8)
            if (String(value) !== "8") return true;

            // courses that are NOT deleted
            const activeCourses = linkCourseData.filter(
              course => course.isDelete !== 1
            );

            // valid if no active courses
            return activeCourses.length === 0;
          }
        ),
      quiz_id: Yup.string().when("quizCheck", {
        is: true,
        then: Yup.string().required("Quiz is required"),
      }),
      AssessmentTotal: Yup.mixed().when(["grading_standard", "GradeType"], {
        is: (grading_standard, GradeType) =>
          Number(grading_standard) === 2 || Number(GradeType) === 4,
        then: Yup.mixed().notRequired(), 
        otherwise: Yup.number()
          .typeError("Assessment Total must be a number")
          .required("Assessment Total is required")
          .min(1, "Assessment Total must be greater than 0"),
      }),
      GradeType: Yup.string().when("grading_standard", {
        is: 2,
        then: Yup.string().notRequired(),
        otherwise: Yup.string().required("Grade Type is required"),
      }),
      openDateAndTime: Yup.string().when("isRequired", {
        is: () => props.lmType !== "selfplaced",
        then: Yup.string().required("Open Date & Time is required"),
      }),
      closeDateAndTime: Yup.string().when("isRequired", {
        is: () => props.lmType !== "selfplaced",
        then: Yup.string()
          .required("Close Date & Time is required")
          .test(
            "is-greater",
            "Close Date & Time should be greater than open date time",
            function (value) {
              const { openDateAndTime } = this.parent;
              return moment(value).isSameOrAfter(moment(openDateAndTime));
            }
          ),
      }),
      maximum_attempts: Yup.string().when("quizCheck", {
        is: true,
        then: Yup.string().required("Maximum Attempts should be at least 1"),
      }),
      passMark: Yup.number().when(["grading_standard", "GradeType"], {
        is: (grading_standard, GradeType) => grading_standard == 2 || GradeType == 4,
        then: Yup.number().nullable(),
        otherwise: Yup.number().when(["AssessmentType", "maxGradeAchievable"], {
          is: (ass_type, maxGrade) => ass_type == 8 || overrideMarkFor > 0,
          then: Yup.number()
            .required("Pass mark is required")
            .max(Yup.ref("maxGradeAchievable"), "Pass mark cannot be more than Maximum Grade Achievable"),
          otherwise: Yup.number().when(["GradeType", "AssessmentTotal"], {
            is: (grade, assessmentTotal) => grade == 0 && assessmentTotal,
            then: Yup.number()
              .required("Pass mark is required")
              .max(100, "Pass mark cannot be more than 100%"),
            otherwise: Yup.number().when(["GradeType", "AssessmentTotal"], {
              is: (grade, assessmentTotal) => grade == 3 && assessmentTotal,
              then: Yup.number()
                .required("Pass mark is required")
                .max(Yup.ref("AssessmentTotal"), "Pass mark cannot be more than Assessment Total"),
              otherwise: Yup.number().required("Pass mark is required"),
            })
          })
        }),
      }),
      gradeMix: Yup.mixed().test(
        "required",
        "Please Assign at least One Grade Mix",
        (value) => {
          if (!tempCheckedAllData?.length && props.gradingStandard == 2) {
            return false;
          } else {
            let isValid = true;
            let errorArr = [];

            tempCheckedAllData.forEach((item) => {
              let errorObj = {
                field_name: [],
                errorMessage: [],
              };

              if (
                item.grading_type != 0 &&
                item.grading_type != 1 &&
                item.grading_type != 2 &&
                item.grading_type != 3
              ) {
                errorObj[`field_name`].push("Grade Type");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Grade Type is required`
                );
                isValid = false;
              }

              if (
                !item.assessment_total ||
                item.assessment_total == "" ||
                item.assessment_total == undefined ||
                item.assessment_total == null
              ) {
                errorObj[`field_name`].push("Assessment Total");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Assessment Total is required`
                );
                isValid = false;
              }

              if (
                item?.aggregation_method_id == 6 && (!item.ass_weighting ||
                  item.ass_weighting == "" ||
                  item.ass_weighting == undefined ||
                  item.ass_weighting == null)
              ) {
                errorObj[`field_name`].push("Weight");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Weight is required`
                );
                isValid = false;
              }

              if (
                item.assessment_total <= 0
              ) {
                errorObj[`field_name`].push("Assessment Total");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Assessment Total Cannot be Negative or 0`
                );
                isValid = false;
              }

              if (
                item.pass_mark === "" ||
                item.pass_mark == undefined ||
                item.pass_mark == null
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark is required`
                );
                isValid = false;
              }

              if (
                (item.grading_type == 3) && item.assessment_total && item.pass_mark && +item.pass_mark >= +item.assessment_total
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark cannot be more than Assessment Total`
                );
                isValid = false;
              }

              if (
                item.grading_type == 0 && 100 < +item.pass_mark
              ) {
                errorObj[`field_name`].push("Pass Mark");
                errorObj[`errorMessage`].push(
                  `${item.name}'s Pass Mark cannot be more than 100%`
                );
                isValid = false;
              }

              if (Object.keys(errorObj.field_name).length) {
                errorArr.push(errorObj);
              } else {
                errorArr.push(false)
              }
            });
            setGradeMixError(errorArr);

            return isValid;
          }
        }
      ),
      linkAssessmentCourse: Yup.mixed().test(
        "course-validation",
        "Course validation failed",
        (value) => {
          if (props.gradingStandard == 2) {
            return true;
          } else {
            let isValid = true;
            let errorArr = [];

            linkCourseData.forEach((item, index) => {
              if (item.isDelete == 1) {
                errorArr.push(false);
                return;
              }

              let errorObj = {
                field_name: [],
                errorMessage: [],
              };

              if (
                item.grading_type != 0 &&
                item.grading_type != 1 &&
                item.grading_type != 2 &&
                item.grading_type != 3 &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Grade Type");
                errorObj.errorMessage.push(`${item.name} Grade Type is required`);
                isValid = false;
              }

              if (item.grading_type != 4) {
                if (item.assessment_total === "" || item.assessment_total === undefined || item.assessment_total === null) {
                  errorObj.field_name.push("Assessment Total");
                  errorObj.errorMessage.push(`${item.name} Assessment Total is required`);
                  isValid = false;
                } else if (item.assessment_total <= 0) {
                  errorObj.field_name.push("Assessment Total");
                  errorObj.errorMessage.push(`${item.name} Assessment Total must be greater than 0`);
                  isValid = false;
                }
              }

              if (
                item?.aggregation_method_id == 6 &&
                (item.weight === "" || item.weight === undefined || item.weight === null) &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Weight");
                errorObj.errorMessage.push(`${item.name} Weight is required`);
                isValid = false;
              }

              if (
                (item.pass_mark === "" ||
                  item.pass_mark === undefined ||
                  item.pass_mark === null) &&
                item.grading_type != 4
              ) {
                errorObj.field_name.push("Pass Mark");
                errorObj.errorMessage.push(`${item.name} Pass Mark is required`);
                isValid = false;
              }

              if (
                item.grading_type == 3 &&
                item.assessment_total !== undefined &&
                item.assessment_total !== null &&
                item.assessment_total !== "" &&
                item.pass_mark !== undefined &&
                item.pass_mark !== null &&
                item.pass_mark !== ""
              ) {
                const assessmentTotal = Number(item.assessment_total);
                const passMark = Number(item.pass_mark);

                if (passMark > assessmentTotal) {
                  errorObj.field_name.push("Pass Mark");
                  errorObj.errorMessage.push(
                    `${item.name} Pass Mark cannot be more than Assessment Total`
                  );
                  isValid = false;
                }

                if (passMark < 0) {
                  errorObj.field_name.push("Pass Mark");
                  errorObj.errorMessage.push(
                    `${item.name} Pass Mark cannot be negative`
                  );
                  isValid = false;
                }
              }

              if (
                item.grading_type == 0 &&
                item.pass_mark !== undefined &&
                item.pass_mark !== null &&
                item.pass_mark !== "" &&
                Number(item.pass_mark) > 100
              ) {
                errorObj.field_name.push("Pass Mark");
                errorObj.errorMessage.push(
                  `${item.name} Pass Mark cannot be more than 100%`
                );
                isValid = false;
              }

              if (errorObj.field_name.length > 0) {
                errorArr.push(errorObj);
              } else {
                errorArr.push(false);
              }
            });

            setCourseError(errorArr);
            return isValid;
          }
        }
      ),
      deadlineDateAndTime: Yup.string()
        .nullable()
        .when("isHybrid", {
          is: (isHybrid) =>
            (isHybrid == true || isHybrid == "true") &&
            props.lmType !== "selfplaced",
          then: Yup.string()
            .nullable()
            .required("Marking Deadline is required")
            .test(
              "is-greater",
              "Marking Date & Time should be greater than closing date time",
              function (value) {
                const { closeDateAndTime } = this.parent;
                return moment(value).isSameOrAfter(moment(closeDateAndTime));
              }
            ),
        }),

      TimeLimitHours: Yup.string().when(
        ["quizCheck", "isDuration", "openDateAndTime", "closeDateAndTime"],
        {
          is: (quizCheck, isDuration, openDateAndTime, closeDateAndTime) =>
            (quizCheck || isDuration) && openDateAndTime && closeDateAndTime,
          then: Yup.string()
            .required("Time Limit Hours is required")
            .test("duration-check", function (value) {
              const {
                TimeLimitMinutes,
                openDateAndTime,
                closeDateAndTime,
              } = this.parent;

              // Only validate when all values exist
              if (value && TimeLimitMinutes && openDateAndTime && closeDateAndTime) {
                const totalMinutes = Number(value) * 60 + Number(TimeLimitMinutes);
                const availableMinutes = moment(closeDateAndTime).diff(
                  moment(openDateAndTime),
                  "minutes"
                );

                if (totalMinutes > availableMinutes) {
                  return this.createError({
                    message: "Time limit exceeds available assessment duration",
                  });
                }
              }

              return true;
            }),
          otherwise: Yup.string().notRequired(),
        }
      ),
      TimeLimitMinutes: Yup.string().when(["quizCheck", "isDuration"], {
        is: (quizCheck, isDuration) => quizCheck == true || isDuration == true,
        then: Yup.string().required("Time Limit Minutes is required"),
      }),
      maxGradeAchievable: Yup.number().nullable().when(["AssessmentType", "GradeType"], {
        is: (ass_type, grade) => (ass_type == 8 || overrideMarkFor > 0) && grade == 0,
        then: Yup.number()
          .required("Maximum Grade Achievable is required")
          .max(100, "Maximum Grade Achievable cannot be more than 100%"),
        otherwise: Yup.number().when(["AssessmentType", "GradeType", "AssessmentTotal"], {
          is: (ass_type, grade, assessmentTotal) => (ass_type == 8 || overrideMarkFor > 0) && grade == 3 && assessmentTotal,
          then: Yup.number()
            .required("Maximum Grade Achievable is required")
            .max(Yup.ref("AssessmentTotal"), "Maximum Grade Achievable cannot be more than Assessment Total"),
        })
      }),
      override_mark_ass_id: Yup.string().when("AssessmentType", {
        is: "9",
        then: Yup.string().required("Please select a assessment to override mark for")
      }),
    }),
    onSubmit: (values, { resetForm }) => {

      if (linkedProgrammes?.isLocked) {
        handleGradesLocked(linkedProgrammes.data, "assessment");
        return;
      } 

      const gradeMix =
        tempCheckedAllData?.length &&
        tempCheckedAllData?.map((data) => ({
          id: data.grade_id ? data.grade_id : data.id,
          offset: parseInt(data?.offset) ? parseInt(data.offset) : "",
          grading_type: parseInt(data?.grading_type),
          multiplicator: parseInt(data?.multiplicator)
            ? parseInt(data.multiplicator)
            : "",
          pass_mark: parseInt(data?.pass_mark),
          grading_template_id: data?.selectedTemplate?.id,
          assessment_total: parseInt(data?.assessment_total),
          ass_weighting: parseInt(data?.ass_weighting)
        }));

      const linkAssessmentCourse = (() => {
        return linkCourseData?.map((data) => ({
          id: data.id || "",
          assessment_id: data.assessment_id || "",
          intake: data.intake ? data.intake : data.id || "",
          grading_type: data.grading_type || "",
          assessment_total: data.assessment_total || "",
          offset: data.offset || "",
          multiplicator: data.multiplicator || "",
          grading_template_id: data?.selectedTemplate?.id || 0,
          pass_mark: data.pass_mark >= 0 ? data.pass_mark : "",
          weight: data.weight || "",
          pass_required: data.pass_required || "",
          exclude_from_calculation: data.exclude_from_calculation || "",
          isDelete: data.isDelete ? 1 : 0,
          created_at: data.created_at || "",
          updated_at: data.updated_at || "",
          course: data.course || "",
          name: data.name || "",
        })) || [];
      })();

      if (
        (values.quizCheck === true || values.isDuration === true) &&
        values.TimeLimitHours == 0 &&
        values.TimeLimitMinutes == 0
      ) {
        formik.setFieldError(
          "TimeLimitHours",
          "Hours must be greater than zero."
        );
        formik.setFieldError(
          "TimeLimitMinutes",
          "Minutes must be greater than zero."
        );
        return;
      } else {
        setAssessmentLoad(true);
        setLoading(true);
        let formData = new FormData();
        type === "open" && formData.set("assessment_id", subId);
        formData.set("intake", id);
        formData.set("name", values?.AssessmentName?.trim());
        formData.set("due", 1);
        formData.set("code", values?.Code);
        formData.set(
          "open_date_time",
          !isNaN(Date.parse(values.openDateAndTime) / 1000)
            ? Date.parse(values.openDateAndTime) / 1000
            : ""
        );
        formData.set(
          "appeal_open_date",
          !isNaN(Date.parse(values.appealOpenDate) / 1000)
            ? Date.parse(values.appealOpenDate) / 1000
            : ""
        );
        formData.set(
          "appeal_close_date",
          !isNaN(Date.parse(values.appealCloseDate) / 1000)
            ? Date.parse(values.appealCloseDate) / 1000
            : ""
        );
        formData.set("allow_appeal", values.allowAppeal ? 1 : 0);
        if (values.allowAppeal === false) {
          formData.set("appeal_open_date", 0);
          formData.set("appeal_close_date", 0);
        }
        formData.set(
          "close_date_time",
          !isNaN(Date.parse(values.closeDateAndTime) / 1000)
            ? Date.parse(values.closeDateAndTime) / 1000
            : ""
        );
        formData.set(
          "marking_deadline_date",
          !isNaN(Date.parse(values.deadlineDateAndTime) / 1000)
            ? Date.parse(values.deadlineDateAndTime) / 1000
            : ""
        );
        formData.set("ass_total_mark", values?.AssessmentTotal);
        if (props?.gradingStandard != 2) {
          formData.set("grade", values.GradeType);
          formData.set("pass_mark", values.passMark);
          formData.set("grading_template_id", selectedTemplate?.id);
          formData.set("multiplicator", values.multiplicator);
          formData.set("offset", values.offset);
          formData.set("linkAssessmentCourse", JSON.stringify(linkAssessmentCourse));
        }
        if (props?.gradingStandard == 2) {
          formData.set("gradeMix", JSON.stringify(gradeMix));
        }
        formData.set("ass_weighting", values?.Weight);
        formData.set(
          "ass_type",
          assessmentTypeSelected || formik.values.AssessmentType
        );

        formData.set("share_with", JSON.stringify(values.shareWith));
        formData.set("ass_marker_sent", 0);
        formData.set("ass_moderator_sent", 1);
        formData.set("timeHour", values?.TimeLimitHours);
        formData.set("timeMin", values?.TimeLimitMinutes);
        formData.set("audio", values?.Audio ? 1 : 0);
        formData.set("camera", values?.Camera ? 1 : 0);
        formData.set("identification", values?.Identification ? 1 : 0);
        formData.set("screen_share", values?.ScreenShare ? 1 : 0);
        formData.append("path_marking", memoFile);
        formData.append("timeLimitActive", values.isDuration ? 1 : 0);
        formData.set("details", editorState);
        if (formik.values.quizCheck) {
          formData.append("quiz_id", quizFormik.values.quiz_id);
          formData.append("maximum_attempts", values.maximum_attempts);
          formData.append("is_student_signature_required", values.is_student_signature_required);
          formData.append("is_marker_signature_required", values.is_marker_signature_required);
        }

        if (!formik.values.quizCheck) {
          formData.append("path", values?.AssessmentFile);
        }
        formData.set("assessment_marker", [...new Set(values.Marker)]);
        formData.set("assessment_moderator", values?.Moderator);
        if (type == "open") {
          formData.append("notify_moderator", values.Moderated);
        }
        if (formik.values.AssessmentType == 8 || overrideMarkFor > 0) {
          formData.set("assigned_std", JSON.stringify(assignedStudentList.map(item => item.student_id)))
          formData.set("maximum_grade_achievable", values.maxGradeAchievable)
        }
        if (formik.values.AssessmentType == 9) {
          formData.set("override_mark_ass_id", values.override_mark_ass_id)
          newAssignee.map((item) => {
            item.files.map((file, ind) => {
              formData.set(`file_${item.student_id}[${ind}]`, file)
            })
            delete item.files
          })
          formData.set(`assigned_std_to_sick`, JSON.stringify(newAssignee));
        }

        if (!(type === "add")) {
          formData.append("path_size", values?.path_size)
        }
        formData.set("is_download_allowed", values.isDownloadAllowed ? 1 : 0);
        formData.append("pass_required", values.pass_required)
        formData.append("exclude_from_calculation", values.exclude_from_calculation)

        AddAssessment(formData)
          .then((res) => {
            setLoading(false);
            if (type == "add") {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Added successfully",
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Updated successfully",
              });
            }

            // resetForm();
            // setImage(user);
            setAssessmentLoad(false)
            if (type == "add" || type == "duplicate") {
              history.push(`/courseAdministration/coursesdetails/${id}/assessments/show`);
            } else {
              setRefresh(!refresh)
              setHandleRefreshCourseList(Date.now())
            }
          })
          .catch((err) => {
            console.error("err :", err);
            setAssessmentLoad(false);
            setLoading(false);

            const rawMessage = err?.response?.data?.message || "";
            const updatedMessage = rawMessage.replace("intakes", "course");

            const isSupplementary = Number(formik.values.AssessmentType) === 8;

            const swalOptions = {
              icon: "error",
              title: isSupplementary
                ? "Failed to create supplementary exam"
                : "Error",
            };

            if (rawMessage) {
              const errors = err?.response?.data?.errors;

              let errorList = "";
              if (Array.isArray(errors) && errors.length > 0) {
                errorList = errors
                  .map((error) => `<li>${error?.name ?? ""}</li>`)
                  .join("");
              }

              swalOptions.html = `
                <div>${updatedMessage}</div>
                ${errorList ? `<br><ul style="text-align:left;">${errorList}</ul>` : ""}
              `;
            } else {
              swalOptions.text = err?.response?.data?.message || "Something went wrong";
            }

 
            Swal.fire(swalOptions);
          });
      }
    },
  });
  
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(()=>{
    formik.setFieldValue("grading_standard",props.gradingStandard)
  },[props.gradingStandard])

  const handleSendInstruction = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("assessment_marker", selectedDomain);
    data.append("intake", id);
    data.append("marking_deadline_date", moment(formik.values.deadlineDateAndTime).format("YYYY-MM-DD HH:mm"));
    data.append("close_date_time", moment(formik.values.closeDateAndTime).format("YYYY-MM-DD HH:mm"));
    data.append("assignmentid", subId);
    data.append("sender", user?.UserID);
    SendAssessmentInstruction(data)
      .then((res) => {
        Swal.fire("Send!", "", "success");
      })
      .catch((error) => {

        Swal.fire("Error!", "", "error");
      });
  };

  const handleMemoDelete = () => {
    setMemoFile("");
    setMemofileName("");
    formik.setFieldValue("MemoFile", "");
  };

  const handleQuizDelete = () => {
    quizFormik.setFieldValue("quiz_id", "");
    setQuizLabel("");
    setIsDurationDisabled(false);
    formik.setFieldValue(
      "AssessmentTotal",
      assessmentDetails
        ? assessmentDetails.ass_total_mark == 0
          ? "0"
          : assessmentDetails?.ass_total_mark
        : ""
    );
    setTempCheckedAllData((prevData) => {
      const newData = prevData.map((item) => ({
        ...item,
        assessment_total: "",
      }));
      return newData;
    });
    formik.setFieldValue(
      "TimeLimitHours",
      assessmentDetails?.timeHour && `${assessmentDetails?.timeHour}`.length
        ? getTimeMinutes(assessmentDetails?.timeHour)
        : "00"
    );
    formik.setFieldValue(
      "TimeLimitMinutes",
      assessmentDetails?.timeMin && `${assessmentDetails?.timeMin}`.length
        ? getTimeMinutes(assessmentDetails?.timeMin)
        : "00"
    );
    // formik.resetForm();
    formik.setFieldValue(
      "isDuration",
      assessmentDetails && assessmentDetails.timeLimitActive ? true : false
    );
    formik.setFieldValue(
      "isAppeal",
      assessmentDetails && assessmentDetails.allowAppeal ? true : false
    );
    formik.setFieldValue(
      "isAppeal",
      assessmentDetails && assessmentDetails.allowAppeal ? true : false
    );
    formik.setFieldValue("quiz_id", "");
    quizFormik.resetForm();
  };

  const hourHandle = () => {
    let hourArr = [];
    for (let i = 0; i <= 23; i++) {
      hourArr.push({
        value: i.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }),
        label:
          i.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }) + "h",
      });
    }
    return hourArr;
  };

  const MinutesHandle = () => {
    let minutesArray = [];

    for (let i = 0; i <= 59; i++) {
      minutesArray.push({
        value: i.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }),
        label:
          i.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }) + "min",
      });
    }
    // ()=>{setMinuteArray(minutesArray)}
    return minutesArray;
  };

  const handleAssessment = () => {
    setAssessmentFile("");
    setAssessmentFileName("");
    formik.setFieldValue("AssessmentFile", "");
  };

  const sort_by = (field, reverse, primer) => {
    const key = primer
      ? function (x) {
        return primer(x[field]);
      }
      : function (x) {
        return x[field];
      };
    reverse = !reverse ? 1 : -1;
    return function (a, b) {
      return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
    };
  };

  const addQuizzHandler = (qid, qlabel, quizData) => {
    quizFormik.setFieldValue("quiz_id", qid);
    formik.setFieldValue("quiz_id", qid);
    setQuizLabel(qlabel);
    setIsDurationDisabled(true);
    quizFormik.handleSubmit();
    $("#quiz").modal("hide");
  };
  const appealOlddate = new Date(formik.values.closeDateAndTime)
  const defaultAppealCloseDate = appealOlddate.setDate(appealOlddate.getDate() + 7)
  const handleRemoveStd = (row) => {
    let tempAssign = assignedStudentList
    let tempAvailable = availableStudentList;
    tempAssign.splice(tempAssign.indexOf(row), 1)
    let ab = tempAvailable.map(item => {
      if (item.student_id === row.student_id) {
        return { ...item, isAssigned: false }
      }
      return item
    })
    setAssignedStudentList([...tempAssign])
    setAvailableStudentList([...ab])
  }

  const handleAddStd = (row) => {
    let tempAssign = assignedStudentList
    let tempAvailable = availableStudentList;
    tempAssign.push({ ...row, isAssigned: true })
    let ab = tempAvailable.map(item => {
      if (item.student_id == row.student_id) {
        return { ...item, isAssigned: true }
      }
      return item
    })
    setAssignedStudentList([...tempAssign])
    setAvailableStudentList([...ab])
  }

  const dataToRenderAvailableStd = () => {
    let updatedData = [];
    let allData = availableStudentList;
    if (availableSearch.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.full_name?.toLowerCase().toString().includes(availableSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempStudentNo = allData.filter((item) => {
        let includes = item.student_crm_id?.toString().toLowerCase().includes(availableSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempStudent, ...tempStudentNo];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (statusAvailable.arr?.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = statusAvailable.arr?.find((post, index) => {
          if (post?.toString() === item?.status.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (courseResultAvailable.arr?.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = courseResultAvailable.arr.find((post, index) => {
          let courseResult = item.pass_status
          if (post.toString() === courseResult.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (availableSearch?.length || statusAvailable.arr?.length || courseResultAvailable.arr?.length) {
      return updatedData;
    } else {
      return availableStudentList;
    }
  };

  const dataToRenderAssignedStd = () => {
    let updatedData = [];
    let allData = assignedStudentList;
    if (searchAssigned.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.full_name?.toLowerCase().toString().includes(searchAssigned.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempStudentNo = allData.filter((item) => {
        let includes = item.student_crm_id?.toString().toLowerCase().includes(searchAssigned.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempStudent, ...tempStudentNo];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (statusAssigned.arr?.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = statusAssigned.arr?.find((post, index) => {
          if (post?.toString() === item?.status.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (courseResultAssigned.arr?.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = courseResultAssigned.arr.find((post, index) => {
          let courseResult = item.pass_status
          if (post.toString() === courseResult.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (searchAssigned?.length || statusAssigned.arr?.length || courseResultAssigned.arr?.length) {
      return updatedData;
    } else {
      return assignedStudentList;
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let isMounted = true;

    if (formik.values.AssessmentType == 9) {
      if (overrideAssessList.length && formik.values.override_mark_ass_id != "") {
        const selectedAssessment = overrideAssessList.find(
          (item) => item.id == formik.values.override_mark_ass_id
        );

        if (!selectedAssessment) return;

        // Only update state if component is still mounted
        if (isMounted) {
          // Batch state updates to reduce re-renders
          setOverrideSelected(selectedAssessment);
          setOverrideMarkFor(selectedAssessment.override_mark_for);

          if (type == "add" || type == "duplicate") {
            if (selectedAssessment.spAssessmentLinks?.length) {
              setLinkCourseData(selectedAssessment.spAssessmentLinks);
              setHandleRefreshCourseList(Date.now());
              const gradingType = selectedAssessment?.spAssessmentLinks?.find((item) => item.grading_type == 2);

              if (gradingType) {
                setSelectedCourse(selectedAssessment?.spAssessmentLinks?.find((item) => item.grading_type == 2)?.selectedTemplate || {});
                setLettertemplateIndex(selectedAssessment?.spAssessmentLinks?.findIndex((item) => item.grading_type == 2));
                setCheckLetterTemplateCourse(true);
              }
            }

            formik.setValues({
              ...formik.values,
              AssessmentTotal: selectedAssessment.ass_total_mark,
              GradeType: selectedAssessment.grading_type,
              passMark: selectedAssessment.pass_mark,
              multiplicator: selectedAssessment.multiplicator,
              offset: selectedAssessment.offset,
              Weight: selectedAssessment.ass_weighting,
              pass_required: selectedAssessment.pass_required,
              exclude_from_calculation: selectedAssessment.exclude_from_calculation
            });
            setGradeSelected(selectedAssessment.grading_type);

            if (selectedAssessment.grading_type == 2) {
              if (isMounted) {
                setAssignLoading(true);
              }

              const data = {
                exportStatus: true,
              };

              GradeLetterTemplateList(data)
                .then(async (res) => {
                  if (isMounted) {
                    let tempObj = res.data.list_data?.find((item) => item.id === selectedAssessment?.grading_template_id);
                    setSelectedTemplate(tempObj);
                    setAssignLoading(false)
                  }
                })
                .catch((err) => {
                  console.error(err);
                  if (isMounted) {
                    setLoading(false);
                    setAssignLoading(false)
                  }
                });

              if (isMounted) {
                setSelectedTemplate(selectedAssessment.selectedTemplate);
                setReload((prev) => !prev);
                setLetterTemplateCourse(false);
              }
            }
          }
        }
      } else {
        if ((type == "add" || type == "duplicate") && isMounted) {
          setOverrideSelected({})
          setOverrideMarkFor("")
          setCheckLetterTemplateCourse(false)
          setLinkCourseData([])
          setCourseError([])

          // Batch reset all formik values at once for better performance
          formik.setValues({
            ...formik.values,
            AssessmentTotal: "",
            GradeType: "",
            passMark: "",
            multiplicator: "",
            offset: "",
            Weight: "",
            pass_required: "",
            exclude_from_calculation: ""
          });

          setGradeSelected("")
          setSelectedTemplate({})
          setLettertemplateIndex(null)
        }
      }
    }

    return () => {
      isMounted = false;
    };
  }, [formik.values.override_mark_ass_id, overrideAssessList, formik.values.AssessmentType])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (gradeSelected) {
      formik.setFieldTouched("AssessmentTotal", true)
      formik.setFieldTouched("passMark", true)
      formik.setFieldTouched("Weight", true)
    }
  }, [gradeSelected]);


  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (formik.values.closeDateAndTime && !formik.values.appealOpenDate) {
      formik.setFieldValue("appealOpenDate", formik.values.closeDateAndTime);

      let appealCloseDate = new Date(formik.values.closeDateAndTime);
      appealCloseDate.setDate(appealCloseDate.getDate() + 7);
      formik.setFieldValue("appealCloseDate", appealCloseDate);
    }
  }, [formik.values.closeDateAndTime, formik.values.appealOpenDate]);

  const dataToRenderOverrideAssess = () => {
    let updatedData = [];
    let allData = overrideAssessList;
    if (overrideSearch.length) {
      let tempAssessment = allData.filter((item) => {
        let includes = item.name?.toLowerCase().toString().includes(overrideSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let data = [...tempAssessment];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (overrideStatus.arr?.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = overrideStatus.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.status.toString().toLowerCase() ? item.status.toString().toLowerCase() : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      })

      updatedData = tempResult;
    }

    if (overrideAssessType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = overrideAssessType.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.type.toString().toLowerCase()) {
            return item;
          }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (overrideSearch?.length || overrideStatus.arr?.length || overrideAssessType.arr?.length) {
      return updatedData;
    } else {
      return overrideAssessList
    }
  }


  const SelectedOverride = () => {
    return (
      <div className="d-flex select-delete">
        <Link
          className="as-text-blue curser"
          title={overrideSelected?.name}
          target="_blank"
          to={overrideSelected?.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${overrideSelected?.id}` : `/courseAdministration/assessment/quizzes/open/details/${overrideSelected?.smart_assignment_id}`}
        >
          <span className="textLimit100">
            {TrimText(overrideSelected?.name, 20)}
          </span>
        </Link>
        <button
          className="btn btn-danger rounded-circle btn-dropdown-item"
          title="Delete"
          onClick={() => {
            formik.setFieldValue("override_mark_ass_id", "");
            formik.setFieldValue("override_mark_ass_type", "");
            formik.setFieldValue("maxGradeAchievable", "")
            setTempCheckedAllData([])
            setCheckedAllRows([])
          }}
          disabled={formik.values.AssessmentType == 9 && assignedStudentList.length && type === "open"}
        >
          <i className="fal fa-trash-alt"></i>
        </button>
      </div>
    )
  }

  const exportDataAvailableStd = () => {
    let data = dataToRenderAvailableStd();
    const header = ["Student", "Student No", "Status", "Course Grade", "Course Result"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Student": row.full_name ? row.full_name : "-",
        "Student No": row.student_crm_id ? row.student_crm_id : "-",
        "Status": row.status ? RenderStudentStatus(row.status).text : "-",
        "Course Grade": row.course_grade ? row.course_grade : "-",
        "Course Result": row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).text : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Student"], row["Student No"], row["Status"], row["Course Grade"], row["Course Result"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  const exportDataAssignedStd = () => {
    let data = dataToRenderAssignedStd();
    const header = ["Student", "Student No", "Status", "Course Grade", "Course Result"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Student": row.full_name ? row.full_name : "-",
        "Student No": row.student_crm_id ? row.student_crm_id : "-",
        "Status": row.status ? RenderStudentStatus(row.status).text : "-",
        "Course Grade": row.course_grade ? row.course_grade : "-",
        "Course Result": row.pass_status ? RenderQuizAttemptResultStatus(row.pass_status).text : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Student"], row["Student No"], row["Status"], row["Course Grade"], row["Course Result"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  const exportDataOverrideFor = () => {
    let data = dataToRenderOverrideAssess();
    const header = ["Name", "Assessment Type", "Status", "Due Date"];

    data = data?.map((row) => {
      return ({
        ...row,
        "Name": row.name ? row.name : "-",
        "Assessment Type": row.type ? RenderAssessmentType(row.type).text : "-",
        "Status": row.status ? RenderAssessmentStatus(row.status).text : "-",
        "Due Date": row.close_date_time_mili ? `${moment.unix(row.close_date_time_mili).format(TABLE_DATE_FORMAT)} ${moment.unix(row.close_date_time_mili).format(TABLE_TIME_FORMAT)}` : "-"
      })
    });
    const pdfData = data.map((row) => {
      return [row["Name"], row["Assessment Type"], row["Status"], row["Due Date"]];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {}
    }
  };

  function handleRemoveFile(file) {
    const selectedFiles = [...selectedFileForAppeal].filter(item => item !== file)
    setSelectedFileForAppeal([...selectedFiles])
  }

  const closeFunction = () => {
    setAppealReason("Sick");
    setStudentMessage("");
    setSelectedFileForAppeal([]);
    setSelectedStudentId();
    $('#assignStudent').modal("hide");
  }

  const handleSaveAppeal = () => {
    if (!studentMessage) {
      setAppealError("Student message is required")
      return
    } else {
      setAppealError("")
    }
    const tempNewAssignee = [...newAssignee]
    tempNewAssignee.push({
      student_id: selectedStudentId,
      studentMessage,
      files: selectedFileForAppeal,
      reason: appealReason
    })
    setNewAssignee(tempNewAssignee)
    const tempAvailableStudent = [...availableStudentList]
    const selectedStudent = tempAvailableStudent.find(item => item.student_id === selectedStudentId)
    tempAvailableStudent.splice(tempAvailableStudent.indexOf(selectedStudent), 1)
    setAvailableStudentList(tempAvailableStudent)
    const tempAssignStd = [...assignedStudentList]
    tempAssignStd.push({ ...selectedStudent, isAssigned: true })
    setAssignedStudentList(tempAssignStd)
    closeFunction()
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (formik.values.AssessmentType == 9) {
      setOverrideLoading(true);
      const values = {
        intake_id: id,
        assessment_id: subId,
        duplicate: type == "duplicate"
      };
      getOverrideAssessments(values)
        .then((res) => {
          if (res.status === 200) {
            setOverrideAssessList(res.data.result);
            setOverrideStatusList(res.data.statusFilter);
            setOverrideAssessTypeList(res.data.assessmentTypeFilter);
          }
        })
        .catch(console.error)
        .finally(() => setOverrideLoading(false));
    }
  }, [formik.values.AssessmentType, refresh]);
  return (
    <>
      <div className="card card-profile-info-card">
        <div className="">
          <div className="card-body-inr card-body-info">
            <form onSubmit={formik.handleSubmit}>
              <div className="edit-icon new-card-header justify-content-between">
                <div className="card-header">
                  Details{" "}
                  {dataLoading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="AssessmentName">Assessment Name *</label>
                    <input
                      // disabled={assessmentActive}
                      type="text"
                      title="Assessment Name"
                      className={
                        "form-control" +
                        (formik.errors.AssessmentName &&
                          formik.touched.AssessmentName
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter Assessment Name"
                      name="AssessmentName"
                      id="AssessmentName"
                      value={formik.values.AssessmentName || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.AssessmentName &&
                      formik.touched.AssessmentName ? (
                      <span className="exclamation">
                        <i className="fal fa-exclamation-circle"></i>
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="Code">Code</label>
                    <input
                      // disabled={assessmentActive}
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors.Code && formik.touched.Code
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter Code"
                      name="Code"
                      title="Code"
                      id="Code"
                      value={formik.values.Code || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.Code && formik.touched.Code ? (
                      <span className="exclamation">
                        <i className="fal fa-exclamation-circle"></i>
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="AssessmentType">Type *</label>
                    <Select
                      isDisabled={(type === "open" && (formik.values.AssessmentType === 9 || formik.values.AssessmentType === 8))}
                      className={
                        "form-control custom-select-box" +
                        (formik.errors.AssessmentType &&
                          formik.touched.AssessmentType
                          ? " is-invalid"
                          : "")
                      }
                      name="AssessmentType"
                      id="AssessmentType"
                      title="Assessment Type"
                      value={assessmentType.filter(function (option) {
                        return option.value == formik.values.AssessmentType;
                      })}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("AssessmentType", value.value);
                          formik.setFieldValue("override_mark_ass_id", "");
                          setassessmentTypeSelected(value.value);
                          if (value.value == 9 || (value.value != 9 && formik.values.AssessmentType == 9)) {
                            setCheckedAllRows([]);
                            setTempCheckedAllData([]);
                          }
                        } else {
                          formik.setFieldValue("AssessmentType", "");
                          formik.setFieldValue("override_mark_ass_id", "");
                          setCheckedAllRows([]);
                          setTempCheckedAllData([]);
                          setassessmentTypeSelected("");
                        }
                      }}
                      placeholder={
                        formik.values.AssessmentType
                          ? formik.values.AssessmentType
                          : "Select Type"
                      }
                      options={assessmentType.sort(
                        sort_by("label", false, (a) => a.toUpperCase())
                      )}
                      isClearable
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.AssessmentType &&
                      formik.touched.AssessmentType ? (
                      <span className="exclamation">
                        <i className="fal fa-exclamation-circle"></i>
                      </span>
                    ) : null}
                  </div>
                </div>

                {props.lmType !== "selfplaced" ? (
                  <>
                    {props.gradingStandard != 2 ? <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <label htmlFor="OpenDate">Open Date &#38; Time *</label>
                        <div className={"datepicker-wrapper"}>
                          <DatePicker
                            selected={formik.values.openDateAndTime}
                            onChange={(date) => {
                              formik.setFieldValue("openDateAndTime", date);
                            }}
                            showTimeSelect
                            filterTime={filterPassedTime}
                            dateFormat={FORM_DATE_TIME_FORMAT}
                            timeFormat={FORM_TIME_FORMAT}
                            showYearDropdown
                            scrollableYearDropdown
                            dateFormatCalendar="MMMM"
                            className={
                              "form-control cursor-pointer" +
                              (formik.errors.openDateAndTime &&
                                formik.touched.openDateAndTime
                                ? " is-invalid"
                                : "")
                            }
                            // disabled={assessmentActive}
                            title="Open Date & Time"
                            onBlur={formik.handleBlur}
                            placeholderText="Select Date & Time"
                            timeIntervals={15}
                            onChangeRaw={(e) => e.preventDefault()}
                            popperPlacement={"auto"}
                            popperModifiers={[
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 10], // You can adjust the offset if needed
                                },
                              },
                              {
                                name: 'flip',
                                enabled: false, // Disable flipping if it's causing issues
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                      : <div className="col-md-6 col-lg-2">
                        <div className="form-group-blk mb-3">
                          <label htmlFor="OpenDate">Open Date &#38; Time *</label>
                          <DatePicker
                            selected={formik.values.openDateAndTime}
                            onChange={(date) => {
                              formik.setFieldValue("openDateAndTime", date);
                            }}
                            showTimeSelect
                            filterTime={filterPassedTime}
                            dateFormat={FORM_DATE_TIME_FORMAT}
                            timeFormat={FORM_TIME_FORMAT}
                            showYearDropdown
                            scrollableYearDropdown
                            dateFormatCalendar="MMMM"
                            className={
                              "form-control cursor-pointer" +
                              (formik.errors.openDateAndTime &&
                                formik.touched.openDateAndTime
                                ? " is-invalid"
                                : "")
                            }
                            // disabled={assessmentActive}
                            title="Open Date & Time"
                            onBlur={formik.handleBlur}
                            placeholderText="Select Date & Time"
                            timeIntervals={15}
                            onChangeRaw={(e) => e.preventDefault()}
                          />
                        </div>
                      </div>
                    }
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <label htmlFor="CloseDate">Close Date &#38; Time *</label>
                        <DatePicker
                          selected={formik.values.closeDateAndTime}
                          onChange={async (date) => {
                            formik.setFieldValue("closeDateAndTime", date);
                            formik.setFieldValue("appealOpenDate", date);
                            let d = new Date(date);
                            let dAppeal = new Date(date);
                            d.setDate(d.getDate() + 14);
                            formik.setFieldValue("deadlineDateAndTime", d);
                            dAppeal.setDate(dAppeal.getDate() + 7);
                            formik.setFieldValue("appealCloseDate", dAppeal);

                            await new Promise(resolve => setTimeout(resolve, 0));
                            formik.validateField("closeDateAndTime");
                            formik.validateField("deadlineDateAndTime");
                          }}
                          showTimeSelect
                          filterTime={filterPassedTime}
                          dateFormat={FORM_DATE_TIME_FORMAT}
                          timeFormat={FORM_TIME_FORMAT}
                          showYearDropdown
                          scrollableYearDropdown
                          dateFormatCalendar="MMMM"
                          className={
                            "form-control cursor-pointer" +
                            (formik.errors.closeDateAndTime &&
                              formik.touched.closeDateAndTime
                              ? " is-invalid"
                              : "")
                          }
                          disabled={(type === "add" && !formik.values.openDateAndTime)
                          }
                          title="Close Date & Time"
                          onBlur={formik.handleBlur}
                          placeholderText="Select Date & Time"
                          timeIntervals={15}
                          onChangeRaw={(e) => e.preventDefault()}
                          minDate={formik.values.openDateAndTime}
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                {props.lmType !== "selfplaced" ? (
                  <div className="col-md-6 col-lg-2">
                    <div className="form-group-blk mb-3">
                      <label htmlFor="MarkingDeadLineDate">
                        Marking Deadline Date &#38; Time
                      </label>

                      <DatePicker
                        selected={formik.values.deadlineDateAndTime}
                        onChange={(date) => {
                          formik.setFieldValue("deadlineDateAndTime", date);
                        }}
                        showTimeSelect
                        filterTime={filterPassedTime}
                        dateFormat={FORM_DATE_TIME_FORMAT}
                        timeFormat={FORM_TIME_FORMAT}
                        showYearDropdown
                        scrollableYearDropdown
                        dateFormatCalendar="MMMM"
                        className={
                          "form-control cursor-pointer" +
                          (formik.errors.deadlineDateAndTime &&
                            formik.touched.deadlineDateAndTime
                            ? " is-invalid"
                            : "")
                        }
                        disabled={
                          // assessmentActive ||
                          !formik.values.closeDateAndTime
                        }
                        title="Deadline Date & Time"
                        onBlur={formik.handleBlur}
                        placeholderText="Select Date & Time"
                        timeIntervals={15}
                        onChangeRaw={(e) => e.preventDefault()}
                        isClearable={
                          formik.values.quizCheck &&
                          formik.values.deadlineDateAndTime
                        }
                        minDate={formik.values.closeDateAndTime}
                      />
                    </div>
                  </div>
                ) : null}
                {props.lmType !== "selfplaced" ? (
                  <div className="col-md-6 col-lg-2">
                    <div className="form-group-blk">
                      <div className="">
                        <label>&nbsp;</label>
                        <div className="custom-check-group">
                          <div
                            className="custom-check custom-control custom-checkbox mt-2"
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="allowAppeal"
                              name="allowAppeal"
                              checked={formik.values.allowAppeal}
                              onChange={(e) =>
                                formik.setFieldValue(
                                  "allowAppeal",
                                  e.target.checked
                                )
                              }
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="allowAppeal"
                            >
                              <div className="mr-3"></div> Appeal
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                {formik.values.allowAppeal == true && (
                  <>
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <label htmlFor="MarkingDeadLineDate">
                          Appeal Open Date
                        </label>
                        <DatePicker
                          selected={
                            formik.values.appealOpenDate
                              ? formik.values.appealOpenDate
                              : formik.values.closeDateAndTime
                          }
                          onChange={(date) => {
                            let dAppeal = new Date(date || formik.values.closeDateAndTime);
                            let d = new Date(dAppeal);
                            formik.setFieldValue("appealOpenDate", dAppeal);

                            d.setDate(d.getDate() + 7);
                            formik.setFieldValue("appealCloseDate", d);
                          }}
                          showTimeSelect
                          filterTime={filterPassedTime}
                          dateFormat={FORM_DATE_TIME_FORMAT}
                          timeFormat={FORM_TIME_FORMAT}
                          showYearDropdown
                          scrollableYearDropdown
                          dateFormatCalendar="MMMM"
                          className={
                            "form-control cursor-pointer" +
                            (formik.errors.appealOpenDate &&
                              formik.touched.appealOpenDate
                              ? " is-invalid"
                              : "")
                          }
                          disabled={
                            // assessmentActive ||
                            !formik.values.closeDateAndTime
                          }
                          title="Close Date & Time"
                          onBlur={formik.handleBlur}
                          placeholderText="Select Date & Time"
                          timeIntervals={15}
                          isClearable={
                            formik.values.closeDateAndTime &&
                            formik.values.appealOpenDate &&
                            new Date(formik.values.closeDateAndTime).getTime() !==
                            new Date(formik.values.appealOpenDate).getTime()
                          }
                          minDate={formik.values.closeDateAndTime}
                          onChangeRaw={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-2">
                      <div className="form-group-blk mb-3">
                        <label htmlFor="MarkingDeadLineDate">
                          Appeal Close Date
                        </label>
                        <DatePicker
                          selected={
                            formik.values.appealCloseDate
                              ? formik.values.appealCloseDate
                              : defaultAppealCloseDate
                          }
                          onChange={(date) => {
                            let d = new Date(date || formik.values.appealOpenDate);
                            if (!date) { d.setDate(d.getDate() + 7); }
                            formik.setFieldValue("appealCloseDate", d);
                          }}
                          showTimeSelect
                          filterTime={filterPassedTime}
                          dateFormat={FORM_DATE_TIME_FORMAT}
                          timeFormat={FORM_TIME_FORMAT}
                          showYearDropdown
                          scrollableYearDropdown
                          dateFormatCalendar="MMMM"
                          className={
                            "form-control cursor-pointer" +
                            (formik.errors.deadlineDateAndTime &&
                              formik.touched.deadlineDateAndTime
                              ? " is-invalid"
                              : "")
                          }
                          disabled={
                            // assessmentActive ||
                            (type === "add" && !formik.values.closeDateAndTime)
                          }
                          title="Appeal Date & Time"
                          onBlur={formik.handleBlur}
                          placeholderText="Select Date & Time"
                          timeIntervals={15}
                          isClearable={
                            formik.values.appealCloseDate &&
                            formik.values.appealOpenDate &&
                            new Date(formik.values.appealCloseDate).getTime() !==
                            new Date(formik.values.appealOpenDate).setDate(
                              new Date(formik.values.appealOpenDate).getDate() + 7
                            )
                          }
                          onChangeRaw={(e) => e.preventDefault()}
                          minDate={formik.values.appealOpenDate}
                        />
                      </div>
                    </div>
                  </>
                )}
                {formik.values.AssessmentType == 8 || overrideMarkFor > 0 ? <div className="col-md-6 col-lg-2">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="maxGradeAchievable"> Maximum Grade Achievable *</label>
                    <input
                      type="number"
                      className={
                        "form-control" +
                        (formik.errors.maxGradeAchievable && formik.touched.maxGradeAchievable
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Maximum Grade Achievable"
                      name="maxGradeAchievable"
                      title="Maximum Grade Achievable"
                      id="maxGradeAchievable"
                      value={formik.values.maxGradeAchievable || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div> : ""}
                {formik.values.AssessmentType == 9 ?
                  <div className="search-filter-div-right mb-4">
                    <label>&nbsp;</label>
                    <div className="filter-search-bar-blk">
                      <div className="add-ticket-blk dropdown-comman">
                        <button data-toggle="modal" data-target="#overrideMarkFor" className={"btn btn-save btn-success " + (formik.errors.override_mark_ass_id && formik.touched.override_mark_ass_id ? " file-req is-invalid" : "")} type="button" title="Override Mark For" disabled={formik.values.AssessmentType == 9 && assignedStudentList.length && type == "open"}>
                          <i className="fal fa-history"></i>Override Mark For
                        </button>
                        {overrideAssessList.length && formik.values.override_mark_ass_id && formik.values.override_mark_ass_id != "" ?
                          <SelectedOverride />
                          : <></>}
                      </div>
                    </div>
                  </div> : null}

                {!formik.values.quizCheck && <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk">
                    <div className="">
                      <label>&nbsp;</label>
                      <div className="custom-check-group">
                        <div
                          className="custom-check custom-control custom-checkbox mt-2"
                        >
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="isDownloadAllowed"
                            name="isDownloadAllowed"
                            checked={
                              formik.values.isDownloadAllowed
                                ? formik.values.isDownloadAllowed
                                : ""
                            }
                            onChange={(e) =>
                              formik.setFieldValue(
                                "isDownloadAllowed",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="isDownloadAllowed"
                          >
                            <div className="mr-3"></div> Allow brief download after completion
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
              <hr />
              <div className="assessment-grade-setting-header">
                <div className="card-header" title="Grade Settings">
                  Grade Settings&nbsp;
                  {dataLoading ? <i className="fas fa-cog fa-spin"></i> : ""}
                </div>
                <PermissionsGate scopes={["caalinkcourse"]} errorProps={{ disabled: true }}>
                  <button
                    data-toggle="modal"
                    data-target={props.gradingStandard == 2 ? "#grademixmodal" : "#link-course-modal"}
                    className="btn btn-save btn-success"
                    type="button"
                    title={`${props.gradingStandard == 2 ? "Assign Grade Mix" : "Link Course"}`}
                    disabled={
                      assignLoading ||
                      formik.values.AssessmentType == 8 ||
                      (props.gradingStandard == 2 && formik.values.AssessmentType == 9) ||
                      moment(formik.values.openDateAndTime).isSameOrBefore(moment().add(1, 'day'), 'day')
                    }
                  >
                    {assignLoading ? <i className="fas fa-cog fa-spin"></i> : <i className={`fal fa-${props.gradingStandard == 2 ? "plus" : "link"}`}></i>} {props.gradingStandard == 2 ? "Assign Grade Mix" : "Link Course"}
                  </button>
                </PermissionsGate>
              </div>

              {props.gradingStandard == 2 ? <>
                <div>
                  <p>
                    <i className="fal fa-info-circle "></i> Assessments created
                    within Programmes using the “Grade Mix” Grading standard
                    require Grade Mix’s to be selected and grade settings to be
                    assigned individually to each Grade Mix to make up the total
                    assessment grade.
                  </p>
                </div>
                {tempCheckedAllData?.length ? (
                  tempCheckedAllData.map((gradeMix, index) => {
                    return (
                      <>
                        <div className="assessment-grade-setting-header">
                          <div className="card-header">
                            <Link
                              className="gradeMix-sidebar-color"
                              to={`/courseAdministration/gradeMix/${gradeMix?.qualification_id}/details/${type !== "add" ? gradeMix.grade_id : gradeMix.id}/open`}
                            >
                              <i className="fal fa-layer-group"></i>{" "}
                              {gradeMix?.name}
                            </Link>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 col-lg-2">
                            <div
                              className={
                                "form-group-blk mb-3" +
                                (gradeMixError[index]?.field_name?.includes("Grade Type")
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <label htmlFor={`GradeType_${gradeMix.id}`}>
                                Grade Type *
                              </label>
                              <Select
                                isDisabled={formik.values.AssessmentType == 9}
                                className={
                                  "form-control custom-select-box" +
                                  (gradeMixError[index]?.field_name?.includes("Grade Type")
                                    ? " is-invalid"
                                    : "")
                                }
                                name={`GradeType_${gradeMix.id}`}
                                id={`GradeType_${gradeMix.id}`}
                                title="Grade Type"
                                placeholder={"Grade Type"}
                                options={gradeMixGradeType}
                                isClearable
                                onChange={(value) => {
                                  setTempCheckedAllData((prevData) => {
                                    const newData = [...prevData];
                                    newData[index].grading_type =
                                      value?.value || null;
                                    return newData;
                                  });
                                  tempCheckedAllData[index].pass_mark = "";
                                  setSelectedGradeMixTemplate({});
                                }}
                                value={gradeMixGradeType.filter(function (option) {
                                  return option.value == gradeMix.grading_type;
                                })}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-2">
                            <div className="form-group-blk mb-3">
                              <label htmlFor={`AssessmentTotal_${gradeMix.id}`}>
                                Assessment Total *
                              </label>
                              <input
                                disabled={quizLabel || formik.values.AssessmentType == 9}
                                type="number"
                                className={
                                  "form-control" +
                                  (gradeMixError[index]?.field_name?.includes("Assessment Total")
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder="Enter Assessment Total"
                                name={`AssessmentTotal_${gradeMix.id}`}
                                title="Assessment Total"
                                id={`AssessmentTotal_${gradeMix.id}`}
                                value={
                                  gradeMix.assessment_total ||
                                  ""
                                }
                                onChange={(event) => {

                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].assessment_total =
                                        event?.target?.value || ""
                                      return newData;
                                    });
                                  }
                                }}
                                min={0}
                              />
                            </div>
                          </div>
                          {gradeMix?.aggregation_method_id == 6 && <div className="col-md-6 col-lg-1">
                            <div className="form-group-blk mb-3">
                              <label htmlFor={`weight_${gradeMix.id}`}>
                                Weight *
                              </label>
                              <input
                                type="number"
                                className={
                                  "form-control" +
                                  (gradeMixError[index]?.field_name?.includes("Weight")
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder="Enter Weight"
                                name={`weight_${gradeMix.id}`}
                                title="Weight"
                                id={`weight_${gradeMix.id}`}
                                value={gradeMix?.ass_weighting || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].ass_weighting =
                                        event?.target?.value || ""
                                      return newData;
                                    });
                                  }
                                }}
                                min={0}
                              />
                            </div>
                          </div>}
                          <div className={`col-md-6 ${gradeMix.aggregation_method_id == 6 ? "col-lg-1" : "col-lg-2"}`}>
                            <div className="form-group-blk mb-3">
                              <label htmlFor={`Offset_${gradeMix.id}`}>
                                Offset{" "}
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                                ></i>
                              </label>
                              <input
                                // disabled={assessmentActive}
                                type="number"
                                className={
                                  "form-control" +
                                  (gradeMixError[index]?.field_name?.includes("Offset")
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder="Offset"
                                name={`Offset_${gradeMix.id}`}
                                title="Offset"
                                id={`Offset_${gradeMix.id}`}
                                value={gradeMix?.offset || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].offset =
                                        event?.target?.value;
                                      return newData;
                                    });
                                  }
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Offset") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-2">
                            <div className="form-group-blk mb-3">
                              <label htmlFor={`multiplicator_${gradeMix.id}`}>
                                Multiplicator{" "}
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                                ></i>
                              </label>
                              <input
                                // disabled={assessmentActive}
                                type="number"
                                className={
                                  "form-control" +
                                  (gradeMixError[index]?.field_name?.includes("Multiplicator")
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder="Multiplicator"
                                name={`multiplicator_${gradeMix.id}`}
                                title="Multiplicator"
                                id={`multiplicator_${gradeMix.id}`}
                                value={gradeMix.multiplicator || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].multiplicator =
                                        event?.target?.value;
                                      return newData;
                                    });
                                  }
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Multiplicator") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {gradeMix.grading_type == "1" ? (
                            <div className="col-md-6 col-lg-2">
                              <div
                                className={
                                  "form-group-blk mb-3" +
                                  (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  Pass Mark&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Pass Mark"
                                  ></i>
                                </label>
                                <Select
                                  className={
                                    "form-control custom-select-box" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`pass_mark_${gradeMix.id}`}
                                  id={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  value={passMarkRobotArr.find((option) => option.value == parseInt(gradeMix.pass_mark)) || null}
                                  onChange={(value) => {
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark =
                                        value?.value == 0
                                          ? 0
                                          : value?.value || "";
                                      return newData;
                                    });
                                  }}
                                  isClearable
                                  options={passMarkRobotArr}
                                  maxMenuHeight={175}
                                  placeholder={"Pass Mark"}
                                />
                              </div>
                            </div>
                          ) : gradeMix.grading_type == "2" ? (
                            <div className="col-md-6 col-lg-2">
                              <div
                                className={
                                  "form-group-blk mb-3" +
                                  (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  Pass Mark&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Pass Mark"
                                  ></i>
                                </label>
                                <Select
                                  className={
                                    "form-control custom-select-box" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`pass_mark_${gradeMix.id}`}
                                  id={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  value={gradeMix.templateOptions?.find((option) => option.value == gradeMix.pass_mark) || null}
                                  onChange={(value) => {
                                    setTempCheckedAllData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark =
                                        value?.value || "";
                                      return newData;
                                    });
                                  }}
                                  isClearable
                                  options={gradeMix?.templateOptions}
                                  maxMenuHeight={175}
                                  placeholder={"Mark"}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="col-md-6 col-lg-2">
                              <div className="form-group-blk mb-3">
                                <label htmlFor={`pass_mark_${gradeMix.id}`}>
                                  {gradeMix.grading_type == "0" ? "Pass Mark % " : gradeMix.grading_type == "3" ? "Pass Mark Value " : "Pass Mark "}
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title={gradeMix.grading_type == "0" ? "Pass Mark as Percentage" : gradeMix.grading_type == "3" ? "Pass Mark as Value" : "Pass Mark"}
                                  ></i>
                                </label>
                                <input
                                  type="number"
                                  className={
                                    "form-control" +
                                    (gradeMixError[index]?.field_name?.includes("Pass Mark")
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Pass Mark"
                                  name={`pass_mark_${gradeMix.id}`}
                                  title="Pass Mark"
                                  id={`pass_mark_${gradeMix.id}`}
                                  value={gradeMix.pass_mark || ""}
                                  onChange={(event) => {
                                    if (
                                      event.target &&
                                      event.target.value !== undefined
                                    ) {
                                      event.persist();
                                      setTempCheckedAllData((prevData) => {
                                        const newData = [...prevData];
                                        newData[index].pass_mark =
                                          event?.target?.value;
                                        return newData;
                                      });
                                    }
                                  }}
                                />
                                {gradeMix.grading_type == "0" ? <span className="percentage-sign">%</span> : ""}
                                {(gradeMixError[index]?.field_name?.includes("Pass Mark")) ? (
                                  <span className="exclamation">
                                    <i className="fal fa-exclamation-circle"></i>
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}
                          {gradeMix.grading_type == "2" && (
                            <div className="search-filter-div-right mb-4">
                              <label>&nbsp;</label>
                              <div className="filter-search-bar-blk">
                                <div className="add-ticket-blk dropdown-comman">
                                  <button
                                    id={`lettertemplate_${gradeMix.id}`}
                                    data-toggle="modal"
                                    data-target="#letterTemplatemodal"
                                    className="btn btn-save btn-success"
                                    type="button"
                                    title="Select Template"
                                    onClick={() => {
                                      setLettertemplateIndex(index);
                                      setReload(!reload);
                                    }}
                                  >
                                    <i className="fal fa-file-alt"></i>Select
                                    Template
                                  </button>
                                  {gradeMix?.selectedTemplate && (
                                    <>
                                      {gradeMix.selectedTemplate &&
                                        gradeMix.selectedTemplate.name && (
                                          <div className="d-flex select-delete">
                                            <Link
                                              className="as-text-blue curser"
                                              title="Open"
                                              to={`/courseAdministration/gradingTemplate/edit/${gradeMix?.selectedTemplate?.id}`}
                                            >
                                              <span className="textLimit100">
                                                {gradeMix.selectedTemplate.name}
                                              </span>
                                            </Link>
                                            <button
                                              className="btn btn-danger rounded-circle btn-dropdown-item"
                                              type="button"
                                              title="Delete"
                                              onClick={() => {
                                                setLettertemplateIndex(index);
                                                setSelectedGradeMixTemplate({});
                                                setTempCheckedAllData(
                                                  (prevData) => {
                                                    const newData = [
                                                      ...prevData,
                                                    ];
                                                    newData[
                                                      index
                                                    ].templateOptions = [];
                                                    newData[
                                                      index
                                                    ].pass_mark = "";
                                                    return newData;
                                                  }
                                                );
                                              }}
                                            >
                                              <i className="fal fa-trash-alt"></i>
                                            </button>
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
              </> : <>
                <div className="card-header" style={{ fontSize: "14px" }} title={intakeDetails?.name}>
                  {intakeDetails?.name}
                </div>
                <div className="row" style={{ columnGap: "30px", padding: "0px 15px" }}>

                  <div className="custom_col_width">
                    <div
                      className={`form-group-blk mb-3 ${formik.errors.GradeType && formik.touched.GradeType ? "is-invalid" : ""}`}
                      title="Grade Type"
                    >
                      <label htmlFor="gradeType">Grade Type *</label>
                      <Select
                        className={`form-control custom-select-box ${formik.errors.GradeType && formik.touched.GradeType ? "is-invalid" : ""}`}
                        name="gradeType"
                        id="gradeType"
                        title="Grade Type"
                        placeholder="Grade Type"
                        options={gradeType}
                        isClearable
                        onBlur={formik.handleBlur}
                        onChange={(value) => {
                          if (value) {
                            formik.setFieldValue("GradeType", value.value);
                            setGradeSelected(value.value);
                            formik.setFieldValue("passMark", "");
                            formik.setFieldValue("AssessmentTotal", quizTotal ? quizTotal : formik.values.AssessmentTotal)
                            setSelectedTemplate({});
                          } else {
                            formik.setFieldValue("GradeType", "");
                            formik.setFieldValue("passMark", "");
                            setGradeSelected("");
                          }
                        }}
                        value={gradeType.filter(function (option) {
                          return option.value == formik.values.GradeType;
                        })}
                      />
                    </div>
                  </div>

                  {formik.values.GradeType != 4 && <>
                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Assessment Total">
                        <label htmlFor="AssessmentTotal">Assessment Total *</label>
                        <input
                          disabled={quizLabel}
                          type="number"
                          className={`form-control ${formik.errors.AssessmentTotal && formik.touched.AssessmentTotal ? "is-invalid" : ""}`}
                          placeholder="Enter Assessment Total"
                          name="AssessmentTotal"
                          title="Assessment Total"
                          id="AssessmentTotal"
                          value={
                            formik.values.AssessmentTotal >= 0 ?
                              formik.values.AssessmentTotal :
                              ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          min={0}
                        />
                      </div>
                    </div>

                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Offset">
                        <label htmlFor="offset">
                          Offset{" "}
                          <i
                            className="fal fa-info-circle grade-icon"
                            title="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                          ></i>
                        </label>
                        <input
                          // disabled={assessmentActive}
                          type="number"
                          className={`form-control ${formik.errors.offset && formik.touched.offset ? "is-invalid" : ""}`}
                          placeholder="Offset"
                          name="offset"
                          title="Offset"
                          id="offset"
                          value={formik.values.offset || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.offset && formik.touched.offset ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Multiplicator">
                        <label htmlFor="multiplicator">
                          Multiplicator{" "}
                          <i
                            className="fal fa-info-circle grade-icon"
                            title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                          ></i>
                        </label>
                        <input
                          // disabled={assessmentActive}
                          type="number"
                          className={`form-control ${formik.errors.multiplicator && formik.touched.multiplicator ? "is-invalid" : ""}`}
                          placeholder="Multiplicator"
                          name="multiplicator"
                          title="Multiplicator"
                          id="multiplicator"
                          value={formik.values.multiplicator || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.multiplicator &&
                          formik.touched.multiplicator ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>

                    {intakeDetails?.aggregation_method_id == 6 && <div className="custom_col_width">
                      <div className="form-group-blk mb-3" title="Weight">
                        <label htmlFor="Weight">Weight *</label>
                        <input
                          type="number"
                          className={`form-control ${formik.errors.Weight && formik.touched.Weight ? "is-invalid" : ""}`}
                          placeholder="Enter Weight"
                          name="Weight"
                          title="Weight"
                          id="Weight"
                          value={formik.values.Weight}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.Weight && formik.touched.Weight ? (
                          <span className="exclamation">
                            <i className="fal fa-exclamation-circle"></i>
                          </span>
                        ) : null}
                      </div>
                    </div>}

                    {gradeSelected == "1" ? (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                          <label htmlFor="passMark">
                            Pass Mark *&nbsp;<i className="fal fa-info-circle grade-icon" title="Enter or select the minimum grade a student must achieve to pass this assignment."></i>
                          </label>
                          <Select
                            className={`form-control custom-select-box ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`}
                            name="passMark"
                            id="passMark"
                            value={passMarkRobotArr.filter((option) => option.value === parseInt(formik.values.passMark))}
                            onChange={(value) => {
                              if (value) {
                                formik.setFieldValue("passMark", value.value);
                              } else {
                                formik.setFieldValue("passMark", "");
                              }
                            }}
                            isClearable
                            options={passMarkRobotArr}
                            maxMenuHeight={175}
                            placeholder={"Mark"}
                          />
                        </div>
                      </div>
                    ) : gradeSelected == "2" ? (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                          <label htmlFor="passMark">
                            Pass Mark *&nbsp;<i className="fal fa-info-circle grade-icon" title="Enter or select the minimum grade a student must achieve to pass this assignment."></i>
                          </label>
                          <Select
                            className={`form-control custom-select-box ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`}
                            name="passMark"
                            id="passMark"
                            title="Pass Mark"
                            value={templatePassMarkArr.filter((option) => option.value == formik.values.passMark)}
                            onChange={(value) => {
                              if (value) {
                                formik.setFieldValue("passMark", value.value);
                              } else {
                                formik.setFieldValue("passMark", "");
                              }
                            }}
                            isClearable

                            options={templatePassMarkArr}
                            maxMenuHeight={175}
                            placeholder={"Mark"}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="custom_col_width">
                        <div className={`form-group-blk mb-3 ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                          <label htmlFor="passMark">
                            {gradeSelected == "0" ? "Pass Mark % * " : gradeSelected == "3" ? "Pass Mark Value * " : "Pass Mark * "}
                            <i
                              className="fal fa-info-circle grade-icon"
                              title="Enter or select the minimum grade a student must achieve to pass this assignment."
                            ></i>
                          </label>
                          <input
                            type="number"
                            className={`form-control ${formik.errors.passMark && formik.touched.passMark ? "is-invalid" : ""}`}
                            placeholder="Pass Mark"
                            name="passMark"
                            title="Pass Mark"
                            id="passMark"
                            value={formik.values.passMark || ""}
                            onChange={(e) => {
                              formik.setFieldValue("passMark", e.target.value)
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.passMark && formik.touched.passMark ? (
                            <span className="exclamation">
                              <i className="fal fa-exclamation-circle"></i>
                            </span>
                          ) : null}
                        </div>
                      </div>
                    )}

                    {gradeSelected == "2" && (
                      <div className="search-filter-div-right mb-4" style={{ marginLeft: 0 }}>
                        <label>&nbsp;</label>
                        <div className="filter-search-bar-blk">
                          <div className="add-ticket-blk dropdown-comman">
                            <button
                              data-toggle="modal"
                              data-target="#letterTemplatemodal"
                              className="btn btn-save btn-success"
                              type="button"
                              title="Select Template"
                              onClick={() => setLetterTemplateCourse(false)}
                            >
                              <i className="fal fa-file-alt"></i>Select Template
                            </button>
                            {selectedTemplate && (
                              <>
                                {selectedTemplate && selectedTemplate?.name && (
                                  <div className="d-flex select-delete" style={{ position: "relative" }}>
                                    <Link
                                      className="as-text-blue curser"
                                      title={selectedTemplate?.name}
                                      to={`/courseAdministration/gradingTemplate/edit/${selectedTemplate?.id}`}
                                      target="_blank"
                                    >
                                      <span className="textLimit100">
                                        {TrimText(selectedTemplate?.name, 20)}
                                      </span>
                                    </Link>
                                    <button
                                      className="btn btn-danger rounded-circle btn-dropdown-item"
                                      title="Delete"
                                      onClick={() => {
                                        formik.setFieldValue("passMark", "");
                                        setSelectedTemplate({})
                                      }}
                                    >
                                      <i className="fal fa-trash-alt"></i>
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="custom_col_width">
                      <div className="form-group-blk" title="Pass Required">
                        <div>
                          <label htmlFor="isPassRequired">&nbsp;</label>
                          <div className="custom-check-group">
                            <div className="custom-check custom-control custom-checkbox mt-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="pass_required"
                                name="pass_required"
                                checked={formik.values.pass_required == 1}
                                onChange={(e) => formik.setFieldValue("pass_required", e.target.checked ? 1 : 0)}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="pass_required"
                              >
                                <div className="mr-3"></div> Pass Required
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {intakeDetails?.aggregation_method_id != 6 && <div className="custom_col_width">
                      <div className="form-group-blk" title="Exclude from Calculation">
                        <div>
                          <label htmlFor="exlcude_from_calculation">&nbsp;</label>
                          <div className="custom-check-group">
                            <div className="custom-check custom-control custom-checkbox mt-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="exclude_from_calculation"
                                name="exclude_from_calculation"
                                checked={formik.values.exclude_from_calculation == 1}
                                onChange={(e) => formik.setFieldValue("exclude_from_calculation", e.target.checked ? 1 : 0)}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="exclude_from_calculation"
                              >
                                <div className="mr-3"></div> Exclude from Calculation
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </>
                  }
                </div>
                {linkCourseData?.length ? linkCourseData.map((courseLink, index) => {
                  if (courseLink.intake == id || courseLink.isDelete == 1) return null;
                  return (
                    <div key={courseLink.id}>
                      <div className="assessment-grade-setting-header mt-3">
                        <div className="card-header" style={{ fontSize: "14px" }} title={courseLink?.name}>
                          <Link
                            target="_blank"
                            to={`/courseAdministration/coursesdetails/${courseLink.intake ? courseLink.intake : courseLink.intakeID}/detailCourses/show`}
                          >
                            {courseLink?.name}
                          </Link>
                        </div>
                        <div className="d-flex btn-dropdown-grp">
                          <div className="as-buttons">
                            <PermissionsGate scopes={["caaunlinkcourse"]} errorProps={{ disabled: true }}>
                              <button
                                type="button"
                                className="btn btn-danger rounded-circle btn-dropdown-item"
                                title="Remove Course"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You want to unassign this course!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      const courseToRemove = linkCourseData.find(course => course.id === courseLink?.id);

                                      if (courseToRemove?.newData) {
                                        setLinkCourseData(prev =>prev.filter(course => course.id !== courseLink?.id));
                                      } else {
                                        setLinkCourseData(prev => {
                                          const updated = prev.map(course =>
                                            course.id === courseLink?.id
                                              ? { ...course, isDelete: 1 }
                                              : course
                                          );
                                          return updated;
                                        });
                                      }
                                      setLinkCheckedAllRows(prev =>prev.filter(id => id !== courseLink?.id));
                                    }
                                  })
                                }}
                              >
                                <i className="fal fa-unlink"></i>
                              </button>
                            </PermissionsGate>
                          </div>

                          <div className="as-buttons">
                            <Link
                              type="button"
                              className="btn btn-save rounded-circle btn-dropdown-item"
                              title="Open"
                              target="_blank"
                              to={`/courseAdministration/coursesdetails/${courseLink.intake ? courseLink.intake : courseLink.intakeID}/detailCourses/show`}
                            >
                              <i className="fal fa-folder-open"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ columnGap: "30px", padding: "0px 15px" }}>
                        <div className="custom_col_width">
                          <div className={`form-group-blk mb-3 ${courseError[index]?.field_name?.includes("Grade Type") ? "is-invalid" : ""}`} title="Grade Type">
                            <label htmlFor={`gradeType_${courseLink.id}`}>
                              Grade Type *
                            </label>
                            <Select
                              className={`form-control custom-select-box ${touchedStates[index]?.gradeType && courseError[index]?.field_name?.includes("Grade Type") ? "is-invalid" : ""}`}
                              name={`gradeType_${courseLink.id}`}
                              id={`gradeType_${courseLink.id}`}
                              title="Grade Type"
                              placeholder={"Grade Type"}
                              options={gradeType}
                              isClearable
                              onBlur={() => {
                                formik.setFieldTouched("linkAssessmentCourse", true)

                                setTouchedStates(prev => {
                                  const isEmpty = !linkCourseData[index]?.grading_type;

                                  const newState = [...prev];
                                  newState[index] = {
                                    ...newState[index],
                                    gradeType: isEmpty
                                  };
                                  return newState;
                                })
                              }}
                              onChange={(value) => {
                                setLinkCourseData((prevData) => {
                                  const newData = [...prevData];
                                  newData[index].grading_type = value?.value;
                                  newData[index].assessment_total = quizTotal ? quizTotal : courseLink.assessment_total;
                                  return newData;
                                });
                                linkCourseData[index].pass_mark = "";
                                linkCourseData[index].templateOptions = [];
                                setLettertemplateIndex(index);
                                setSelectedCourse({})

                                setTouchedStates(prev => {
                                  const newState = [...prev];
                                  newState[index] = {
                                    ...newState[index],
                                    gradeType: false
                                  };
                                  return newState;
                                })

                                formik.setFieldTouched("linkAssessmentCourse", true)
                              }}
                              value={gradeType.filter((option) => option.value == courseLink.grading_type)}
                            />
                          </div>
                        </div>
                        {courseLink?.grading_type != 4 && <>
                          <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Assessment Total">
                              <label htmlFor={`AssessmentTotal_${courseLink.id}`}>
                                Assessment Total *
                              </label>
                              <input
                                disabled={quizLabel}
                                type="number"
                                className={`form-control ${touchedStates[index]?.assessmentTotal && courseError[index]?.field_name?.includes("Assessment Total") ? "is-invalid" : ""}`}
                                placeholder="Enter Assessment Total"
                                name={`AssessmentTotal_${courseLink.id}`}
                                id={`AssessmentTotal_${courseLink.id}`}
                                value={courseLink.assessment_total}
                                onBlur={() => {
                                  formik.setFieldTouched("linkAssessmentCourse", true)
                                  setTouchedStates(prev => {
                                    const isEmpty = !linkCourseData[index]?.assessment_total || linkCourseData[index]?.assessment_total == 0;
                                    const newState = [...prev];
                                    newState[index] = {
                                      ...newState[index],
                                      assessmentTotal: isEmpty
                                    };
                                    return newState;
                                  })
                                }}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].assessment_total = event?.target?.value
                                      return newData;
                                    });
                                    setTouchedStates(prev => {
                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        assessmentTotal: false
                                      };
                                      return newState;
                                    })

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }
                                }}
                                min={0}
                              />
                            </div>
                          </div>
                          <div className={`custom_col_width`}>
                            <div className="form-group-blk mb-3" title="Offset">
                              <label htmlFor={`Offset_${courseLink.id}`}>
                                Offset&nbsp;
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Enter a value to be added to each student's raw score for this assignment. This can be used to adjust the difficulty of the assignment or to provide a bonus. For example, an offset of 5 would add 5 points to every student's score. A negative value can be used to subtract points. The default value is typically 0."
                                ></i>
                              </label>
                              <input
                                type="number"
                                className={`form-control ${courseError[index]?.field_name?.includes("Offset") ? "is-invalid" : ""}`}
                                placeholder="Offset"
                                name={`Offset_${courseLink.id}`}
                                title="Offset"
                                id={`Offset_${courseLink.id}`}
                                value={courseLink?.offset || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].offset = event?.target?.value;
                                      return newData;
                                    });

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Offset") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Multiplicator">
                              <label htmlFor={`multiplicator_${courseLink.id}`}>
                                Multiplicator&nbsp;
                                <i
                                  className="fal fa-info-circle grade-icon"
                                  title="Specify the factor by which the raw score of the assignment will be multiplied. This can be used to adjust the weight of the assignment in the overall grading scheme. For example, a multiplicator of 2 would double the score of this assignment in the context of overall grading. The default value is typically 1."
                                ></i>
                              </label>
                              <input
                                type="number"
                                className={`form-control ${courseError[index]?.field_name?.includes("Multiplicator") ? "is-invalid" : ""}`}
                                placeholder="Multiplicator"
                                name={`multiplicator_${courseLink.id}`}
                                title="Multiplicator"
                                id={`multiplicator_${courseLink.id}`}
                                value={courseLink.multiplicator || ""}
                                onChange={(event) => {
                                  if (
                                    event.target &&
                                    event.target.value !== undefined
                                  ) {
                                    event.persist();
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].multiplicator = event?.target?.value;
                                      return newData;
                                    });

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }
                                }}
                              />
                              {gradeMixError[index]?.field_name?.includes("Multiplicator") ? (
                                <span className="exclamation">
                                  <i className="fal fa-exclamation-circle"></i>
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {courseLink?.aggregation_method_id == 6 && <div className="custom_col_width">
                            <div className="form-group-blk mb-3" title="Weight">
                              <label htmlFor={`weight_${courseLink.id}`}>
                                Weight *
                              </label>
                              <input
                                type="number"
                                className={`form-control ${touchedStates[index]?.weight && courseError[index]?.field_name?.includes("Weight") ? "is-invalid" : ""}`}
                                placeholder="Enter Weight"
                                name={`weight_${courseLink.id}`}
                                title="Weight"
                                id={`weight_${courseLink.id}`}
                                value={courseLink?.weight}
                                onBlur={() => {
                                  formik.setFieldTouched("linkAssessmentCourse", true)

                                  setTouchedStates(prev => {
                                    const isEmpty = !linkCourseData[index]?.weight;

                                    const newState = [...prev];
                                    newState[index] = {
                                      ...newState[index],
                                      weight: isEmpty
                                    };
                                    return newState;
                                  })
                                }}
                                onChange={(event) => {
                                  if (event.target && event.target.value != undefined) {
                                    event.persist();
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].weight = event?.target?.value
                                      return newData;
                                    });

                                    setTouchedStates(prev => {
                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        weight: true
                                      };
                                      return newState;
                                    })

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }
                                }}
                                min={0}
                              />
                            </div>
                          </div>}

                          {courseLink?.grading_type == 1 ? (
                            <div className="custom_col_width">
                              <div className={`form-group-blk mb-3 ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <label htmlFor={`pass_mark_${courseLink.id}`}>
                                  Pass Mark *&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                  ></i>
                                </label>
                                <Select
                                  className={`form-control custom-select-box ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`}
                                  name={`pass_mark_${courseLink.id}`}
                                  id={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  value={passMarkRobotArr.filter((option) => option.value == parseInt(courseLink.pass_mark))}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true)

                                    setTouchedStates(prev => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;

                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: courseLink.pass_mark >= courseLink.assessment_total ? true : isEmpty
                                      };
                                      return newState;
                                    })
                                  }}
                                  onChange={(value) => {
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark = value?.value;
                                      return newData;
                                    });

                                    setTouchedStates(prev => {
                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: false
                                      };
                                      return newState;
                                    })

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }}
                                  isClearable
                                  options={passMarkRobotArr}
                                  maxMenuHeight={175}
                                  placeholder={"Pass Mark"}
                                />
                              </div>
                            </div>
                          ) : courseLink?.grading_type == 2 ? (
                            <div className="custom_col_width">
                              <div className={`form-group-blk mb-3 ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`} title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <label htmlFor={`pass_mark_${courseLink.id}`}>
                                  Pass Mark *&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                  ></i>
                                </label>
                                <Select
                                  className={`form-control custom-select-box ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`}
                                  name={`pass_mark_${courseLink.id}`}
                                  id={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  value={courseLink.templateOptions?.filter((option) => option.value == courseLink.pass_mark)}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true)

                                    setTouchedStates(prev => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;

                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: courseLink.pass_mark >= courseLink.assessment_total ? true : isEmpty
                                      };
                                      return newState;
                                    })
                                  }}
                                  onChange={(value) => {
                                    setLinkCourseData((prevData) => {
                                      const newData = [...prevData];
                                      newData[index].pass_mark = value?.value;
                                      return newData;
                                    });

                                    setTouchedStates(prev => {
                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: false
                                      };
                                      return newState;
                                    })

                                    formik.setFieldTouched("linkAssessmentCourse", true)
                                  }}
                                  isClearable
                                  options={courseLink?.templateOptions}
                                  maxMenuHeight={175}
                                  placeholder={"Mark"}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="custom_col_width">
                              <div className="form-group-blk mb-3" title="Enter or select the minimum grade a student must achieve to pass this assignment.">
                                <label htmlFor={`pass_mark_${courseLink.id}`}>
                                  {`Pass Mark ${courseLink?.grading_type == "0" ? "%" : courseLink?.grading_type == "3" ? "Value" : ""} *`}&nbsp;
                                  <i
                                    className="fal fa-info-circle grade-icon"
                                    title="Enter or select the minimum grade a student must achieve to pass this assignment."
                                  ></i>
                                </label>
                                <input
                                  type="number"
                                  className={`form-control ${touchedStates[index]?.passMark && courseError[index]?.field_name?.includes("Pass Mark") ? "is-invalid" : ""}`}
                                  placeholder="Pass Mark"
                                  name={`pass_mark_${courseLink.id}`}
                                  title="Pass Mark"
                                  id={`pass_mark_${courseLink.id}`}
                                  value={courseLink.pass_mark || ""}
                                  onBlur={() => {
                                    formik.setFieldTouched("linkAssessmentCourse", true)

                                    setTouchedStates(prev => {
                                      const isEmpty = !linkCourseData[index]?.pass_mark;

                                      const newState = [...prev];
                                      newState[index] = {
                                        ...newState[index],
                                        passMark: courseLink.pass_mark >= courseLink.assessment_total ? true : isEmpty
                                      };
                                      return newState;
                                    })
                                  }}
                                  onChange={(event) => {
                                    if (
                                      event.target &&
                                      event.target.value !== undefined
                                    ) {
                                      event.persist();
                                      setLinkCourseData((prevData) => {
                                        const newData = [...prevData];
                                        newData[index].pass_mark = event?.target?.value;
                                        return newData;
                                      });

                                      setTouchedStates(prev => {
                                        const newState = [...prev];
                                        newState[index] = {
                                          ...newState[index],
                                          passMark: false
                                        };
                                        return newState;
                                      })

                                      formik.setFieldTouched("linkAssessmentCourse", true)
                                    }
                                  }}
                                />
                                {(courseError[index]?.field_name?.includes("Pass Mark")) ? (
                                  <span className="exclamation">
                                    <i className="fal fa-exclamation-circle"></i>
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}

                          {courseLink?.grading_type == 2 && (
                            <div className="search-filter-div-right mb-4" style={{ marginLeft: 0 }}>
                              <label>&nbsp;</label>
                              <div className="filter-search-bar-blk">
                                <div className="add-ticket-blk dropdown-comman">
                                  <button
                                    id={`lettertemplate_${courseLink.id}`}
                                    data-toggle="modal"
                                    data-target="#letterTemplatemodal"
                                    className="btn btn-save btn-success"
                                    type="button"
                                    title="Select Template"
                                    // disabled={props.gradingStandard == 2}
                                    onClick={() => {
                                      const isEmpty = (obj) => {
                                        return !obj || Object.keys(obj).length === 0;
                                      };

                                      if (courseLink?.newData && isEmpty(courseLink?.selectedTemplate)) {
                                        setSelectedCourse({})
                                      } else if (courseLink?.selectedTemplate) {
                                        setSelectedCourse(courseLink?.selectedTemplate)
                                      }

                                      setLettertemplateIndex(index);
                                      setReload(!reload);
                                      setLetterTemplateCourse(true)
                                    }}
                                  >
                                    <i className="fal fa-file-alt"></i> Select
                                    Template
                                  </button>
                                  {courseLink?.selectedTemplate && (
                                    <>
                                      {courseLink?.selectedTemplate &&
                                        courseLink?.selectedTemplate?.name && (
                                          <div className="d-flex select-delete" style={{ position: "relative" }}>
                                            <Link
                                              className="as-text-blue curser"
                                              title="Open"
                                              to={`/courseAdministration/gradingTemplate/edit/${courseLink?.selectedTemplate?.id}`}
                                              onClick={() => {
                                                $("#letterTemplatemodal").modal("hide");
                                              }}
                                            >
                                              <span className="textLimit100">
                                                {courseLink?.selectedTemplate?.name}
                                              </span>
                                            </Link>
                                            <button
                                              className="btn btn-danger rounded-circle btn-dropdown-item"
                                              type="button"
                                              title="Delete"
                                              onClick={() => {
                                                setLettertemplateIndex(index);
                                                setSelectedCourse({})
                                                setLinkCourseData((prevData) => {
                                                  const newData = [...prevData];
                                                  newData[index].selectedTemplate = null;
                                                  newData[index].templateOptions = [];
                                                  newData[index].pass_mark = "";
                                                  return newData;
                                                }
                                                );

                                                formik.setFieldTouched("linkAssessmentCourse", true)
                                              }}
                                            >
                                              <i className="fal fa-trash-alt"></i>
                                            </button>
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="custom_col_width">
                            <div className="form-group-blk">
                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-check-group">
                                  <div className="custom-check custom-control custom-checkbox mt-2">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={`pass_required${courseLink.id}`}
                                      name={`pass_required${courseLink.id}`}
                                      checked={courseLink?.pass_required == 1}
                                      onChange={(e) => {
                                        setLinkCourseData((prevData) => {
                                          const newData = [...prevData];
                                          newData[index].pass_required = e.target.checked ? 1 : 0;
                                          return newData;
                                        })

                                        formik.setFieldTouched("linkAssessmentCourse", true)
                                      }}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={`pass_required${courseLink.id}`}
                                    >
                                      <div className="mr-3"></div> Pass Required
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {courseLink?.aggregation_method_id != 6 && <div className="custom_col_width">
                            <div className="form-group-blk">
                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-check-group">
                                  <div className="custom-check custom-control custom-checkbox mt-2">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={`exclude_from_calculation${courseLink.id}`}
                                      name={`exclude_from_calculation${courseLink.id}`}
                                      checked={courseLink?.exclude_from_calculation == 1}
                                      onChange={(e) => {
                                        setLinkCourseData((prevData) => {
                                          const newData = [...prevData];
                                          newData[index].exclude_from_calculation = e.target.checked ? 1 : 0;
                                          return newData;
                                        })

                                        formik.setFieldTouched("linkAssessmentCourse", true)
                                      }
                                      }
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={`exclude_from_calculation${courseLink.id}`}
                                    >
                                      <div className="mr-3"></div> Exclude from Calculation
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>}
                        </>
                        }
                      </div>
                    </div>
                  );
                }
                )
                  : null}
              </>
              }
              <hr />
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group-blk mb-3">
                    <label>Detailed instructions</label>
                    {(apiDataLoaded || type == "add") && (
                      <HtmlInputEditor
                        editorState={editorState}
                        setEditorState={setEditorState}
                        // readOnly={assessmentActive}
                        isInValid={editorState}
                        isCKEditor={true}
                        hideSign={true}
                      />
                    )}
                    {formik.errors.DetailedInstruction &&
                      formik.touched.DetailedInstruction ? (
                      <span className="exclamation">
                        <i className="fal fa-exclamation-circle"></i>
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
              {formik.values.AssessmentType == 8 || formik.values.AssessmentType == 9 ? <>
                <hr />
                <div className="edit-icon new-card-header">
                  <div className="card-header">Assigned Students</div>
                </div>
                <DataTableComponentFrontPagination
                  isInsidePopUp
                  data={dataToRenderAssignedStd()}
                  columns={studentColumns}
                  loading={assignloading}
                  exportData={exportDataAssignedStd}
                  search={searchAssigned}
                  setSearch={setSearchAssigned}
                  exportFileName="Assigned_Students"
                  tableButton={[
                    <button className="btn btn-primary" title="Assign Students" type="button" data-toggle="modal" data-target="#availableStudents" disabled={(formik.values.AssessmentType == 9 && !formik.values.override_mark_ass_id)}>
                      <i className="fal fa-plus"></i>Assign Students
                    </button>
                  ]}
                  filters={[
                    {
                      filterName: "Status",
                      optionArr: statusAssignedList,
                      state: statusAssigned,
                      setState: setStatusAssigned,
                      renderLabelFunction: RenderStudentStatus,
                      uniqueId: "assignedStatus"
                    },
                    {
                      filterName: "Course Result",
                      optionArr: courseResultAssignedList,
                      state: courseResultAssigned,
                      setState: setCourseResultAssigned,
                      renderLabelFunction: RenderQuizAttemptResultStatus,
                      uniqueId: "assigned"
                    }
                  ]}
                />
              </> : ""}
              <hr />
              <div className="edit-icon new-card-header">
                <div className="card-header">Resources</div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="form-icon-group" title="">
                    <div className="prefix-sufix-box">
                      <div
                        style={{ zIndex: "inherit" }}
                        className="custom-control custom-radio custom-control-inline"
                        title="Quiz"
                      >
                        <input
                          type="radio"
                          id="quiz1"
                          name="quizCheck"
                          checked={formik.values.quizCheck}
                          onChange={() => {
                            formik.setFieldValue("quizCheck", true);
                            setQuizLabel("");
                            setIsDurationDisabled(true);
                          }}
                          className="custom-control-input"
                          disabled={type !== "add" && assessmentDetails.getSubmissionCount > 0}
                        />
                        <label
                          className="custom-control-label custom-control-inline"
                          htmlFor="quiz1"
                        >
                          Quiz
                        </label>
                      </div>
                      {/* } */}
                      <div
                        style={{ zIndex: "inherit" }}
                        className="custom-control custom-radio custom-control-inline"
                        title="Document"
                      >
                        <input
                          type="radio"
                          id="document"
                          name="quizCheck"
                          checked={!formik.values.quizCheck}
                          onChange={() => {
                            formik.setFieldValue("quizCheck", false);
                            setQuizLabel("");
                            setIsDurationDisabled(false);
                          }}
                          className="custom-control-input"
                          disabled={type !== "add" && assessmentDetails.getSubmissionCount > 0}
                        />
                        <label
                          className="custom-control-label custom-control-inline"
                          htmlFor="document"
                        >
                          Document
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {formik.values.quizCheck
                ? (
                  <>
                    <div className="form-group-blk assest-custom-left">
                      <label>Add Quiz *</label>
                      <div className="form-group atttach-file m-0">
                        <label
                          className={
                            formik.errors.quiz_id && formik.touched.quiz_id
                              ? "file-req is-invalid"
                              : ""
                          }

                          data-toggle={(type !== "add" && assessmentDetails.getSubmissionCount > 0) ? "" : "modal"}
                          type="button"
                          data-target="#quiz"
                          title="Add Quiz"
                          onClick={() => {
                            if (type !== "add" && assessmentDetails.getSubmissionCount > 0) {
                              return false
                            }
                          }}
                        >
                          <i className="fal fa-plus"></i>Add Quiz
                        </label>
                      </div>
                    </div>

                    <div className="row assest-custom">
                      <div className="col-md-4">
                        <div className="d-flex">
                          <div className="mb-3">
                            {quizLabel && quizFormik.values.quiz_id > 0 && (
                              <>
                                <div className="frm-group">
                                  <ul className="list-unstyled attached-file-ul m-0">
                                    <li>
                                      <a
                                        href={`/courseAdministration/assessment/quizzes/open/details/${quizFormik.values.quiz_id}`}
                                        target="_blank"
                                      >
                                        <i className="fal fa-file"></i>
                                        &nbsp;{" "}
                                        <span title={quizLabel}>
                                          {TrimText(quizLabel, 40)}
                                        </span>
                                      </a>
                                      <button
                                        className="btn btn-danger rounded-circle btn-dropdown-item"
                                        title="Delete"
                                        disabled={type !== "add" && assessmentDetails.getSubmissionCount > 0}
                                        onClick={() => handleQuizDelete()}
                                      >
                                        <i className="fal fa-trash-alt"></i>
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}


              <>
                {(formik.values.quizCheck && (formik.values.isHybrid == true || formik.values.isHybrid == "true")) || !formik.values.quizCheck ?
                  <div className="row">
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group-blk mb-3">
                        <label htmlFor="Marker">Marker</label>
                        <Select
                          // isDisabled={assessmentActive}
                          className={
                            "form-control custom-select-box is-multi color-drop " +
                            (formik.errors.Marker && formik.touched.Marker
                              ? " is-invalid"
                              : "")
                          }
                          name="Marker"
                          title="Marker"
                          onChange={(value) => {
                            if (value) {
                              let arr = [];
                              value.map((item) => {
                                arr.push(item.value);
                              });
                              formik.setFieldValue("Marker", arr);
                            } else {
                              formik.setFieldValue("Marker", []);
                            }
                          }}
                          value={moderatorAndMarker.filter((obj) => {
                            return formik.values.Marker.includes(obj.value);
                          })}
                          isMulti={true}
                          options={moderatorAndMarker.sort(
                            sort_by("label", false, (a) => a.toUpperCase())
                          )}
                          maxMenuHeight={175}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                    {type === "open" && (
                      <div className="col-md-2">
                        <div className="form-group-blk mb-3">
                          <label>&nbsp;</label>
                          <div className="form-group form-group-save-cancel">
                            <button
                              disabled={!formik.values.Marker}
                              className="btn btn-save btn-success"
                              type="button"
                              onClick={(e) => handleSendInstruction(e)}
                            >
                              <i className="fal fa-paper-plane"></i>Send
                              Instruction
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {type === "open" && (
                      <div className="custom-check custom-control custom-checkbox mt-2 ">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheckModerated"
                          name="select"
                          checked={formik.values.Moderated == "1"}
                          // disabled={assessmentActive}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "Moderated",
                              e.target.checked == true ? "1" : "0"
                            )
                            formik.setFieldValue("Moderator", "");
                            setModeratorSelected("");
                          }
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheckModerated"
                        >
                          Moderated
                        </label>
                      </div>
                    )}
                    {formik.values.Moderated == "1" &&
                      (
                        <div className="col-md-6 col-lg-4">
                          <div className="">
                            <label htmlFor="Moderator">Moderator</label>
                            <div className="form-icon-group mb-4 ">
                              <Select
                                // isDisabled={assessmentActive}
                                className={"form-control custom-select-box"}
                                name="Moderator"
                                title="Moderator"
                                placeholder={
                                  formik.values.Moderator
                                    ? formik.values.Moderator
                                    : "Moderator"
                                }
                                maxMenuHeight={175}
                                options={moderatorAndMarker.sort(myCompare)}
                                onBlur={formik.handleBlur}
                                onChange={(value) => {
                                  if (value) {
                                    formik.setFieldValue("Moderator", value.value);
                                    setModeratorSelected(value.value);
                                  } else {
                                    formik.setFieldValue("Moderator", "");
                                    setModeratorSelected("");
                                  }
                                }}
                                value={moderatorAndMarker.filter(function (option) {
                                  return option.value == formik.values.Moderator;
                                })}
                                isClearable
                              />
                            </div>
                          </div>
                        </div>
                      )}
                  </div> : null}
                <div className="row assest-custom">
                  {formik.values.quizCheck ? null : (
                    <>
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk assest-custom-left">
                            <label>Assessment</label>
                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.AssessmentFile &&
                                    formik.touched.AssessmentFile
                                    ? "file-req is-invalid"
                                    : ""
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Add Attachment</span>
                                <input
                                  ref={assessmentFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  title="Add Attachment"
                                  className="form-control form-control-aatch-file"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;

                                    formik.setFieldValue("AssessmentFile", file);
                                    setAssessmentFile(file);
                                    setAssessmentFileName(file.name);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                          <button
                            className="btn btn-save btn-success mt-4 ml-3"
                            type="button"
                            title="Browse AMI"
                            disabled={assessmentActive}
                            onClick={() => assessmentFileInputRef.current?.click()}
                          >
                            <i className="fal fa-cloud-download"></i> Browse AMI
                          </button>
                        </div>

                        {assessmentFileName && (
                          <>
                            <div className="frm-group">
                              <ul className="list-unstyled attached-file-ul m-0">
                                <li>
                                  <a
                                    title={assessmentFileName}
                                    href={
                                      assessmentFileName.includes("blob") || assessmentFileName.startsWith("https://s3.af-south-1.amazonaws.com/")
                                        ? assessmentFileName
                                        : formatUrl(assessmentFileName)
                                    }
                                    target="_blank"
                                  >
                                    <i className="fal fa-file"></i>
                                    &nbsp;
                                    {TrimText(
                                      assessmentFile?.name ??
                                      formik.values.AssessmentFile?.split("/")?.pop() ??
                                      "",
                                      40
                                    )}
                                  </a>
                                  <button
                                    className="btn btn-danger rounded-circle btn-dropdown-item"
                                    title="Delete"
                                    onClick={() => handleAssessment()}
                                  >
                                    <i className="fal fa-trash-alt"></i>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="d-flex">
                          <div className="form-group-blk mb-3">
                            <label>Memo</label>
                            <div className="form-group atttach-file m-0">
                              <label
                                className={
                                  formik.errors.MemoFile &&
                                  formik.touched.MemoFile &&
                                  "file-req is-invalid"
                                }
                              >
                                <i className="fal fa-paperclip"></i>
                                <span>Add Attachment</span>
                                <input
                                  ref={memoFileInputRef}
                                  disabled={assessmentActive}
                                  type="file"
                                  className="form-control form-control-aatch-file"
                                  title="Add Attachment"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;

                                    formik.setFieldValue("MemoFile", file);
                                    setMemoFile(file);
                                    setMemofileName(file.name);
                                  }}
                                />
                              </label>
                            </div>
                          </div>
                          <button
                            className="btn btn-save btn-success mt-4 ml-3"
                            type="button"
                            title="Browse AMI"
                            disabled={assessmentActive}
                            onClick={() => memoFileInputRef.current?.click()}
                          >
                            <i className="fal fa-cloud-download"></i> Browse AMI
                          </button>
                        </div>

                        {memofileName &&
                          memofileName != "null" &&
                          memofileName != undefined && (
                            <>
                              <div className="frm-group">
                                <ul className="list-unstyled attached-file-ul m-0">
                                  <li>
                                    <a
                                      title={memofileName}
                                      href={
                                        memofileName.includes("blob")
                                          ? memofileName : formatUrl(memofileName)
                                      }
                                      target="_blank"
                                    >
                                      <i className="fal fa-file"></i>
                                      &nbsp;
                                      {TrimText(
                                        memoFile?.name
                                          ? memoFile?.name
                                          : formik.values.MemoFile.split(
                                            "/"
                                          ).reverse()[0],
                                        40
                                      )}
                                    </a>
                                    <button
                                      className="btn btn-danger rounded-circle btn-dropdown-item"
                                      title="Delete"
                                      onClick={() => handleMemoDelete()}
                                    >
                                      <i className="fal fa-trash-alt"></i>
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </>
                          )}
                      </div>
                    </>
                  )}

                  <div className="col-md-6 col-lg-4">
                    <div className="form-group-blk mb-4">
                      <label htmlFor="shareWith">Share With</label>
                      <Select
                        // isDisabled={assessmentActive}
                        className={"form-control color-drop custom-select-box is-multi"}
                        name="shareWith"
                        title="shareWith"
                        placeholder={
                          formik.values.shareWith.length
                            ? formik.values.shareWith
                            : "Share With"
                        }
                        maxMenuHeight={175}
                        options={moderatorAndMarker.sort(myCompare)}
                        onBlur={formik.handleBlur}
                        onChange={(value) => {
                          if (value && value.length) {
                            formik.setFieldValue("shareWith", value.map((item => parseInt(item.value))));
                          } else {
                            formik.setFieldValue("shareWith", "");
                          }
                        }}
                        value={moderatorAndMarker.filter((option) => formik.values.shareWith.includes(parseInt(option.value)))}
                        isClearable
                        isMulti={true}
                      />
                    </div>
                  </div>

                  {formik.values.quizCheck ? <>
                    <div className="col-md-6 col-lg-2 offset-lg-4 d-flex" style={{ marginTop: 37 }} title="Require Student Declaration">
                      <label className="mb-0">
                        Require Student Declaration <i className="fal fa-info-circle"></i>
                      </label>
                      <div className="toggle-switch ml-2">
                        <label className="switch">
                          <input
                            type="checkbox"
                            id="is_student_signature_required"
                            checked={formik.values.is_student_signature_required === 1}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "is_student_signature_required",
                                e.target.checked ? 1 : 0
                              )
                            }
                            }
                          />
                          <span className="slider slider-round"></span>
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-2 d-flex" style={{ marginTop: 37 }} title="Require Marker Signature">
                      <label className="mb-0">
                        Require Marker Signature <i className="fal fa-info-circle"></i>
                      </label>
                      <div className="toggle-switch ml-2">
                        <label className="switch">
                          <input
                            type="checkbox"
                            id="is_marker_signature_required"
                            checked={formik.values.is_marker_signature_required === 1}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "is_marker_signature_required",
                                e.target.checked ? 1 : 0
                              )
                            }
                            }
                          />
                          <span className="slider slider-round"></span>
                        </label>
                      </div>
                    </div> </> : null}
                </div>
              </>

              <hr />
              <div className="edit-icon new-card-header">
                <div className="card-header">Assessment Conditions</div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <div className="d-flex w-100">
                    <div className="form-group-blk mb-3 mr-2">
                      <label>&nbsp;</label>
                      <div className="custom-check-group">
                        <div
                          className="custom-check custom-control custom-checkbox mt-2"
                          style={{ width: "100px" }}
                        >
                          <input
                            disabled={isDurationDisabled}
                            type="checkbox"
                            className="custom-control-input"
                            id="durationCheckbox"
                            name="select"
                            checked={formik.values.isDuration}
                            onChange={(e) =>
                              formik.setFieldValue("isDuration", e.target.checked)
                            }
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="durationCheckbox"
                          >
                            <i className="fal fa-clock"></i> Duration
                          </label>
                        </div>
                      </div>
                    </div>
                    {formik.values.isDuration && (
                      <div className="form-group-blk mb-3 w-100">
                        <label>Time Limit</label>
                        <div className="row form-grp-dates time-select">
                          <Select
                            className={
                              "form-control custom-select-box" +
                              (formik.errors.TimeLimitHours &&
                                formik.touched.TimeLimitHours
                                ? " is-invalid"
                                : "")
                            }
                            name="Hour"
                            title="Time Limit Hour"
                            placeholder={
                              formik.values.TimeLimitHours
                                ? formik.values.TimeLimitHours
                                : "Hours"
                            }
                            options={hourHandle()}
                            onBlur={formik.handleBlur}
                            onChange={(value) => {
                              if (value) {
                                formik.setFieldValue(
                                  "TimeLimitHours",
                                  value.value
                                );
                              } else {
                                formik.setFieldValue("TimeLimitHours", "");
                              }
                            }}
                            value={hourHandle().filter((val) => {
                              return (
                                val.value == formik.values.TimeLimitHours
                              );
                            })}
                            isClearable
                          />
                          <Select
                            className={
                              "form-control custom-select-box" +
                              (formik.errors.TimeLimitMinutes &&
                                formik.touched.TimeLimitMinutes
                                ? " is-invalid"
                                : "")
                            }
                            name="Minute"
                            title="Time Limit Minute"
                            placeholder={
                              formik.values.TimeLimitMinutes
                                ? formik.values.TimeLimitMinutes
                                : "Minutes"
                            }
                            options={MinutesHandle()}
                            onBlur={formik.handleBlur}
                            onChange={(value) => {
                              if (value) {
                                formik.setFieldValue(
                                  "TimeLimitMinutes",
                                  value.value
                                );
                              } else {
                                formik.setFieldValue("TimeLimitMinutes", "");
                              }
                            }}
                            value={MinutesHandle().filter((val) => {
                              return (
                                val.value == formik.values.TimeLimitMinutes
                              );
                            })}
                            isClearable
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 col-lg-6 ml-auto d-flex justify-content-end">
                  <div className="form-group-blk mb-3">
                    <label>&nbsp;</label>
                    <div className="custom-check-group">
                      <div className="custom-check custom-control custom-checkbox mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck1"
                          name="select"
                          checked={formik.values.Identification || false}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "Identification",
                              e.target.checked
                            )
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck1"
                        >
                          <i className="fal fa-portrait"></i> Identification
                        </label>
                      </div>
                      <div className="custom-check custom-control custom-checkbox mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck2"
                          name="select"
                          checked={formik.values.Camera || false}
                          onChange={(e) =>
                            formik.setFieldValue("Camera", e.target.checked)
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck2"
                        >
                          <i className="fal fa-webcam"></i> Camera
                        </label>
                      </div>
                      <div className="custom-check custom-control custom-checkbox mt-2 mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck3"
                          name="select"
                          checked={formik.values.ScreenShare || false}
                          onChange={(e) =>
                            formik.setFieldValue("ScreenShare", e.target.checked)
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck3"
                        >
                          <i className="fal fa-desktop"></i> Screenshare
                        </label>
                      </div>
                      <div className="custom-check custom-control custom-checkbox mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck4"
                          name="select"
                          checked={formik.values.Audio || false}
                          onChange={(e) =>
                            formik.setFieldValue("Audio", e.target.checked)
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck4"
                        >
                          <i className="fal fa-microphone"></i> Audio
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {formik.values.quizCheck == true ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group-blk mb-3">
                      <label htmlFor="maximum_attempts">Maximum Attempts *</label>
                      <input
                        type="number"
                        title="Maximum Attempts"
                        className={
                          "form-control" +
                          (formik.errors.maximum_attempts &&
                            formik.touched.maximum_attempts
                            ? " is-invalid"
                            : "")
                        }
                        placeholder="Enter Maximum Attempts"
                        name="maximum_attempts"
                        id="maximum_attempts"
                        value={formik.values.maximum_attempts || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group form-group-save-cancel mt-3 mb-0">
                <div>
                  <PermissionsGate scopes={type === "open" ? ["castedit"] : ["castadd"]} errorProps={{ disabled: true }}>
                    <button
                      className="btn btn-save btn-success"
                      type="submit"
                      title="Save"
                      onClick={() => {
                        if (linkCourseData.length > 0) {
                          formik.setFieldTouched("linkAssessmentCourse", true)

                          setTouchedStates(linkCourseData?.map(() => ({
                            gradeType: true,
                            assessmentTotal: true,
                            passMark: true,
                            weight: true
                          })));
                        }
                      }}
                      disabled={assessmentLoad || isDisabled ? true : false}
                    >
                      {assessmentLoad === false ? (
                        <i className="fal fa-save"></i>
                      ) : (
                        <i className="fas fa-cog fa-spin"></i>
                      )}
                      Save
                    </button>
                  </PermissionsGate>
                  <button
                    className="btn btn-close btn-danger"
                    type="reset"
                    title="Cancel"
                    onClick={() => {
                      if (!formik.dirty) {
                        history.goBack();
                      } else {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "Your work will not be saved",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, Go Back!",
                        })
                          .then((result) => {
                            if (result.isConfirmed) {
                              history.goBack();
                            }
                          })
                          .catch((error) => {
                            console.error("error: ", error);
                          });
                      }
                    }}
                  >
                    <i className="fal fa-times"></i>Cancel
                  </button>
                </div>
                {Object.keys(formik.values).map((key) => {
                  if (formik.touched[key] && formik.errors[key]) {
                    if (key == "gradeMix") {
                      if (tempCheckedAllData.length) {
                        return gradeMixError.map((item) => {

                          if (!item) {
                            return <></>
                          }
                          return item.errorMessage.map((error) => (
                            <div className="invalid-feedback d-block">
                              {error}
                            </div>
                          ))
                        }
                        );
                      } else {
                        return (
                          <div className="invalid-feedback d-block">
                            {formik.errors[key]}
                          </div>
                        );
                      }
                    } else if (key == "linkAssessmentCourse") {
                      if (linkCourseData.length) {
                        return courseError.map((item, index) => {
                          if (!item) {
                            return null;
                          }

                          const shouldShowGradeTypeError = touchedStates[index]?.gradeType;
                          const shouldShowAssessmentTotalError = touchedStates[index]?.assessmentTotal;
                          const shouldShowPassMarkError = touchedStates[index]?.passMark;
                          const shouldShowweightError = touchedStates[index]?.weight;

                          const filteredErrors = item.errorMessage.filter((error) => {
                            if (error.toLowerCase().includes('grade type') && !shouldShowGradeTypeError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('assessment total') && !shouldShowAssessmentTotalError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('pass mark') && !shouldShowPassMarkError) {
                              return false;
                            }
                            if (error.toLowerCase().includes('Weight') && !shouldShowweightError) {
                              return false;
                            }
                            return true;
                          });

                          if (filteredErrors.length === 0) {
                            return null;
                          }

                          return filteredErrors.map((error, errorIndex) => (
                            <div key={`error-${index}-${errorIndex}`} className="invalid-feedback d-block">
                              {error}
                            </div>
                          ));
                        });
                      } else {
                        return (
                          <div className="invalid-feedback d-block">
                            {formik.errors[key]}
                          </div>
                        );
                      }
                    }
                    return (
                      <div className="invalid-feedback d-block" key={key}>
                        {formik.errors[key]}
                      </div>
                    );
                  }
                })}
              </div>
            </form>
          </div>
        </div>
        {formik.values.quizCheck && <div
          className="topic-add-modal modal able_modal01 fade"
          id="quiz"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered available-assessment-modal"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-body p-0">
                <div className="modal-header modal-header-custom">
                  <h5 className="modal-title">
                    <i className="fal fa-plus"></i> Add Quiz
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <AddQuizzTable addQuizzHandler={addQuizzHandler} />
              </div>
            </div>
          </div>
        </div>}
        {(formik.values.GradeType == 2 || linkCourseData?.some(link => link?.grading_type == 2)) && <ListOfTemplateModal
          setSelectedTemplate={setSelectedTemplate}
          selectedTemplate={selectedTemplate}
          setSelectedGradeMixTemplate={setSelectedGradeMixTemplate}
          letterTemplateCourse={letterTemplateCourse}
          setSelectedCourse={setSelectedCourse}
          selectedCourse={selectedCourse}
          setLetterTemplateCourse={setLetterTemplateCourse}
        />}
        {formik.values.grading_standard === 2 && <ProgrammeGradeMixModal
          setTempCheckedAllData={setTempCheckedAllData}
          tempCheckedAllData={tempCheckedAllData}
          setCheckedAllRows={setCheckedAllRows}
          checkedAllRows={checkedAllRows}
          courseId={id}
          setSelectedGradeMixTemplate={setSelectedGradeMixTemplate}
          quizTotal={quizTotal}
          type={type}
        />}
        <PopupComponent
          id="availableStudents"
          header={{
            iconName: "fa-user-plus",
            heading: "Assign Student"
          }}
          tableData={{
            exportData: exportDataAvailableStd,
            exportFileName: "Assigned_Students",
            data: dataToRenderAvailableStd(),
            columns: studentColumns,
            setSearch: setAvailableSearch,
            search: availableSearch,
            loading: availableLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: statusAvailableList,
                state: statusAvailable,
                setState: setStatusAvailable,
                renderLabelFunction: RenderStudentStatus,
                uniqueId: "availableStatus"
              },
              {
                filterName: "Course Result",
                optionArr: courseResultAvailableList,
                state: courseResultAvailable,
                setState: setCourseResultAvailable,
                renderLabelFunction: RenderQuizAttemptResultStatus,
                uniqueId: "available"
              }
            ]
          }}
        />
        <PopupComponent
          id="overrideMarkFor"
          header={{
            iconName: "fa-exchange",
            heading: "Override Mark For"
          }}
          tableData={{
            exportData: exportDataOverrideFor,
            exportFileName: "Available_assessment",
            data: dataToRenderOverrideAssess(),
            columns: overrideAssessColumns,
            setSearch: setOverrideSearch,
            search: overrideSearch,
            loading: overrideLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: overrideStatusList,
                state: overrideStatus,
                setState: setOverrideStatus,
                renderLabelFunction: RenderAssessmentStatus
              },
              {
                filterName: "Assessment Type",
                optionArr: overrideAssessTypeList,
                state: overrideAssessType,
                setState: setOverrideAssessType,
                renderLabelFunction: RenderAssessmentType
              }
            ]
          }}
        />
        <PopupComponent
          id="availableStudents"
          header={{
            iconName: "fa-user-plus",
            heading: "Assign Student"
          }}
          tableData={{
            exportData: exportDataAvailableStd,
            exportFileName: "Assigned_Students",
            data: dataToRenderAvailableStd(),
            columns: studentColumns,
            setSearch: setAvailableSearch,
            search: availableSearch,
            loading: availableLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: statusAvailableList,
                state: statusAvailable,
                setState: setStatusAvailable,
                renderLabelFunction: RenderStudentStatus,
                uniqueId: "availableStatus"
              },
              {
                filterName: "Course Result",
                optionArr: courseResultAvailableList,
                state: courseResultAvailable,
                setState: setCourseResultAvailable,
                renderLabelFunction: RenderQuizAttemptResultStatus,
                uniqueId: "available"
              }
            ]
          }}
        />
        <PopupComponent
          id="overrideMarkFor"
          header={{
            iconName: "fa-exchange",
            heading: "Override Mark For"
          }}
          tableData={{
            exportData: exportDataOverrideFor,
            exportFileName: "Available_assessment",
            data: dataToRenderOverrideAssess(),
            columns: overrideAssessColumns,
            setSearch: setOverrideSearch,
            search: overrideSearch,
            loading: overrideLoading,
            filters: [
              {
                filterName: "Status",
                optionArr: overrideStatusList,
                state: overrideStatus,
                setState: setOverrideStatus,
                renderLabelFunction: RenderAssessmentStatus
              },
              {
                filterName: "Assessment Type",
                optionArr: overrideAssessTypeList,
                state: overrideAssessType,
                setState: setOverrideAssessType,
                renderLabelFunction: RenderAssessmentType
              }
            ]
          }}
        />
        <PopupComponent
          closeFunction={closeFunction}
          id="assignStudent"
          type="multiple_details_blocks"
          header={{
            iconName: "fa-comment",
            heading: "Appeals"
          }}
          detailsBlocks={[
            {
              heading: "Registered Appeal",
              columns: [
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title popup-detail-block">
                          Reason for not submitting assessment:{" "}
                        </span>
                        <span className="popup-detail-block">
                          <select
                            className="form-control"
                            name="reason"
                            id="reason"
                            value={appealReason}
                            onChange={e => setAppealReason(e.target.value)}
                          >
                            <option value="Sick" >Sick</option>
                            <option value="Family Responsibility">Family Responsibility</option>
                            <option value="Pre-Arranged Appeal">Pre-Arranged Appeal</option>
                            <option value="Portal Difficulties">Portal Difficulties</option>
                            <option value="Other">Other</option>
                          </select>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>,
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title popup-detail-block">Description: </span>
                        <span className="text-break popup-detail-block">
                          <div className="fmInput">
                            <textarea className="form-control"
                              onChange={e => setStudentMessage(e.target.value)}
                              value={studentMessage}
                              placeholder="Description"
                              name="description"
                              id="description" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>,
                <div className="col-md-12">
                  <div className="basic-info-box-list modal-info-list">
                    <ul className="appeal-submission-list">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group-blk mb-3">
                            <li>
                              <span className="title popup-detail-block">
                                Supporting File :
                              </span>
                              <span className="d-block popup-detail-block">
                                <div className="fmInput">
                                  <Dropzone onDrop={acceptedFiles => {
                                    setSelectedFileForAppeal([...selectedFileForAppeal, acceptedFiles[0]])
                                  }} accept=".zip,.jpg,.png,.jpeg,.pdf,.doc,.docx,.txt">
                                    {({ getRootProps, getInputProps }) => (
                                      <section>
                                        <div {...getRootProps()}>
                                          <input {...getInputProps()} />
                                          <p>Drag & drop files here, or click to select files</p>
                                        </div>
                                      </section>
                                    )}
                                  </Dropzone>
                                  {selectedFileForAppeal.map((item, index) => {
                                    return <span key={index}>
                                      <span>
                                        <i className="fal fa-file"></i>
                                        &nbsp;{item.name}
                                      </span>
                                      <button className="btn btn-danger rounded-circle" onClick={() => handleRemoveFile(item)} type="button" title="Delete">
                                        <i className="fal fa-trash-alt"></i>
                                      </button>
                                    </span>
                                  })}
                                </div>
                              </span>
                            </li>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              ]
            },
          ]}
          bottomButton={[
            <button
              type="button"
              className="btn btn-success"
              title="Save"
              onClick={handleSaveAppeal}
            >
              <i className="fal fa-save"></i> Save
            </button>,
            <button
              type="button"
              className="btn btn-danger"
              title="Cancel"
              onClick={closeFunction}
              data-target="#assignStudent"
              data-toggle="modal"
            >
              <i className="fal fa-times"></i> Cancel
            </button>
          ]}
          validationErrorMessage={[
            appealError
          ]}
          otherProps={
            {
              secondPopupCss: "zindexadd appeal-by-admin"
            }
          }
        />
      </div>
      {(intakeDetails && intakeDetails.subject_type !== 'short course') ?
        <LinkCourseModal
          setLinkCourseData={setLinkCourseData}
          linkCourseData={linkCourseData}
          linkCheckedAllRows={linkCheckedAllRows}
          setLinkCheckedAllRows={setLinkCheckedAllRows}
          formik={formik}
          handleRefreshCourseList={handleRefreshCourseList}
          sickAssessmentId={formik.values.override_mark_ass_id}
        />
        : ''}
    </>
  );
};

export default AssessmentForm;
